const fieldOptions = {
  openToWorkOptions: [
    { key: 'Yes', label: 'Yes' },
    { key: 'No', label: 'No' },
  ],

  workAuthCandidateOptions: [
    { key: 'Authorized to work in the U.S. without employer sponsorship', label: 'Authorized to work in the U.S. without employer sponsorship' },
    { key: 'Authorized to work in the U.S. and requires current/future employer sponsorship', label: 'Authorized to work in the U.S. and requires current/future employer sponsorship' },
    { key: 'Authorized to work in the U.S. for a limited duration (with valid work authorization/EAD)', label: 'Authorized to work in the U.S. for a limited duration (with valid work authorization/EAD)' },
    // { key: 'Legally authorized to work in the U.S.', label: 'Legally authorized to work in the U.S.' },
    // { key: 'U.S. Citizen', label: 'U.S. Citizen' },
    // { key: 'Lawful Permanent Resident (Green Card holder)', label: 'Lawful Permanent Resident (Green Card holder)' },
  ],

  candidateSkillsOptions: [
    { key: 'react', label: 'React' },
    { key: 'angular', label: 'Angular' },
    { key: 'SAP', label: 'SAP' },
    { key: 'AWS', label: 'AWS' },
    { key: 'Salesforce', label: 'Salesforce' },
    { key: 'Sailpoint', label: 'Sailpoint' },
    { key: 'Azure', label: 'Azure' },
    { key: 'GCP', label: 'GCP' },
    { key: 'Workday', label: 'Workday' },
    { key: 'ServiceNow', label: 'ServiceNow' },
    { key: 'Oracle', label: 'Oracle' },
    { key: 'Microsoft Dynamics', label: 'Microsoft Dynamics' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  driversLicenceAvailableOptions: [
    { key: 'Yes', label: 'Yes' },
    { key: 'No', label: 'No' },
  ],

  workTypeOptions: [
    { key: 'C2C', label: 'C2C' },
    { key: 'W2', label: 'W2' },
    { key: 'C2H', label: 'C2H' },
  ],

  workSiteOptions: [
    { key: 'Onsite', label: 'On-site' },
    { key: 'Remote', label: 'Remote' },
    { key: 'Hybrid', label: 'Hybrid' },
  ],

  workAuthTypeOptions: [
    // Category A - Requires Current/Future Employer Sponsorship
    { key: 'H-1B', label: 'H-1B' },
    { key: 'H-1B1', label: 'H-1B1' },
    { key: 'E-3', label: 'E-3' },
    { key: 'O-1', label: 'O-1' },
    { key: 'L-1A', label: 'L-1A' },
    { key: 'L-1B', label: 'L-1B' },
    { key: 'TN', label: 'TN' },
    { key: 'R-1', label: 'R-1' },
    { key: 'P-1/P-2/P-3', label: 'P-1 / P-2 / P-3' },
    { key: 'Q-1', label: 'Q-1' },
    { key: 'E-1', label: 'E-1' },
    { key: 'E-2', label: 'E-2' },
    { key: 'J-1', label: 'J-1' },
    { key: 'L2S', label: 'L2S' },
    // Category B - Limited Duration (EAD / Student Authorization)
    { key: 'F-1 OPT', label: 'F-1 OPT' },
    { key: 'STEM OPT', label: 'F-1 STEM OPT Extension' },
    { key: 'CPT', label: 'CPT' },
    { key: 'J-1 Academic Training', label: 'J-1 Academic Training' },
    { key: 'M-1 Practical Training', label: 'M-1 Practical Training' },
    { key: 'EAD', label: 'Employment Authorization Document (EAD)' },
    // { key: 'Asylum Applicant', label: 'Asylum applicants' },
    // Category C - Permanent Work Authorization (No Sponsorship)
    { key: 'US Citizen', label: 'U.S. Citizen' },
    { key: 'Green Card', label: 'Lawful Permanent Residents' },
    { key: 'Asylee', label: 'Asylees' },
    { key: 'Refugee', label: 'Refugees' },
    { key: 'Withholding of Removal', label: 'Individuals granted withholding of removal' },
    { key: 'Cuban/Haitian Entrant', label: 'Cuban/Haitian entrants with permanent authorization' },
    // { key: 'VAWA Self-Petitioner', label: 'Certain VAWA self-petitioners with unrestricted EAD' },
    { key: 'Permanent Work Auth', label: 'Individuals with permanent work authorization not tied to an employer' },
    // { key: 'add_new_option', label: '-- Add New --' },
  ],

  eadCategoryOptions: [
    { key: 'a2', label: '(a)(2) - Lawful temporary resident' },
    { key: 'a3', label: '(a)(3) - Refugee' },
    { key: 'a4', label: '(a)(4) - Paroled refugee' },
    { key: 'a5', label: '(a)(5) - Asylee' },
    { key: 'a6', label: '(a)(6) - Fiancé(e) (K-1 or K-2 nonimmigrant)' },
    { key: 'a7', label: '(a)(7) - N-8 or N-9' },
    { key: 'a8', label: '(a)(8) - Citizen of Micronesia, Marshall Islands, or Palau' },
    { key: 'a9', label: '(a)(9) - K-3 or K-4' },
    { key: 'a10', label: '(a)(10) - Withholding of deportation or removal granted' },
    { key: 'a11', label: '(a)(11) - Deferred Enforced Departure' },
    { key: 'a12', label: '(a)(12) - Temporary Protected Status granted' },
    { key: 'a13', label: '(a)(13) - Family Unity Program (Section 301 of the Immigration Act of 1990)' },
    { key: 'a14', label: '(a)(14) - LIFE Legalization (Section 1504 of the Legal Immigrant Family Equity (LIFE) Act Amendments)' },
    { key: 'a15', label: '(a)(15) - V visa nonimmigrant' },
    { key: 'a16', label: '(a)(16) - T-1 nonimmigrant' },
    { key: 'a17', label: '(a)(17) - Spouse of an E nonimmigrant' },
    { key: 'a18', label: '(a)(18) - Spouse of an L nonimmigrant' },
    { key: 'a19', label: '(a)(19) - U-1 nonimmigrant' },
    { key: 'a20', label: '(a)(20) - U-2, U-3, U-4, or U-5 nonimmigrant' },
    { key: 'c1', label: '(c)(1) - Spouse/dependent of A-1 or A-2 visa nonimmigrant' },
    { key: 'c2', label: '(c)(2) - Spouse/dependent of Coordination Council for North American Affairs (E-1)/ Taipei Economic and Cultural Representative Office (TECRO)' },
    { key: 'c3a', label: '(c)(3)(A) - F-1 student, pre-completion Optional Practical Training' },
    { key: 'c3b', label: '(c)(3)(B) - F-1 student, post-completion Optional Practical Training' },
    { key: 'c3c', label: '(c)(3)(C) - F-1 student, 24-month extension for STEM students' },
    { key: 'c3ii', label: '(c)(3)(ii) - F-1 student, off-campus employment sponsored by a qualifying international organization' },
    { key: 'c3iii', label: '(c)(3)(iii) - F-1 student, off-campus employment due to severe economic hardship' },
    { key: 'c4', label: '(c)(4) - Spouse/dependent of G-1, G-3, or G-4' },
    { key: 'c5', label: '(c)(5) - J-2 spouse or child of J-1 exchange visitor' },
    { key: 'c6', label: '(c)(6) - M-1 student, Practical Training' },
    { key: 'c7', label: '(c)(7) - Dependent of NATO-1 through NATO-6' },
    { key: 'c8_post_jan4_1995', label: '(c)(8) - Asylum application pending filed on/after Jan. 4, 1995' },
    { key: 'c8_pre_jan4_1995_not_in_proceedings', label: '(c)(8) - Asylum application pending filed before Jan. 4, 1995 and applicant is not in exclusion/deportation proceedings' },
    { key: 'c8_pre_jan4_1995_in_proceedings', label: '(c)(8) - Asylum application pending filed before Jan. 4, 1995 and applicant is in exclusion/deportation proceedings' },
    { key: 'c8_abc', label: '(c)(8) - Asylum application under ABC Agreement' },
    { key: 'c9', label: '(c)(9) - Pending adjustment of status under Section 245 of the Act' },
    { key: 'c10', label: '(c)(10) - Suspension of deportation applicants (filed before April 1, 1997) Cancellation of Removal applicants Cancellation applicants under NACARA' },
    { key: 'c11', label: '(c)(11) - Public Interest parolee' },
    { key: 'c12', label: '(c)(12) - Spouse of an E-2 CNMI investor' },
    { key: 'c14', label: '(c)(14) - Deferred action' },
    { key: 'c16', label: '(c)(16) - Creation of record (adjustment based on continuous residence since Jan. 1, 1972)' },
    { key: 'c17i', label: '(c)(17)(i) - B-1 domestic servant of certain nonimmigrants' },
    { key: 'c17ii', label: '(c)(17)(ii) - B-1 domestic servant of certain U.S. citizens who are in the United States on a temporary basis.' },
    { key: 'c17iii', label: '(c)(17)(iii) - Certain B-1 nonimmigrant employees of a foreign airline' },
    { key: 'c18', label: '(c)(18) - Order of supervision' },
    { key: 'c19', label: '(c)(19) - Certain pending TPS applicants whom USCIS has determined are prima facie eligible for TPS and who may then receive an EAD as a "temporary treatment benefit" under 8 C.F.R. 244.10(a).' },
    { key: 'c20', label: '(c)(20) - Section 210 legalization (pending I-700)' },
    { key: 'c21', label: '(c)(21) - S visa nonimmigrant' },
    { key: 'c22', label: '(c)(22) - Section 245A legalization (pending I-687)' },
    { key: 'c23', label: '(c)(23) - Irish peace process (Q-2)' },
    { key: 'c24', label: '(c)(24) - LIFE legalization' },
    { key: 'c25', label: '(c)(25) - T-2, T-3, T-4, T-5, or T-6 nonimmigrant' },
    { key: 'c26', label: '(c)(26) - Spouse of an H-1B nonimmigrant' },
    { key: 'c31', label: '(c)(31) - VAWA self-petitioners with an approved Form I-360' },
    { key: 'c33', label: '(c)(33) - Consideration of Deferred Action for Childhood Arrivals (DACA)' },
    { key: 'c35', label: '(c)(35) - Principal beneficiary of an approved employment-based immigrant petition facing compelling circumstances' },
    { key: 'c36', label: '(c)(36) - Spouse or unmarried child of a principal beneficiary of an approved employment-based immigrant petition facing compelling circumstances' },
  ],

  geographiesServedOptions: [
    { key: 'local', label: 'Local' },
    { key: 'multi_state', label: 'Multi-State' },
    { key: 'national', label: 'National' },
    { key: 'global', label: 'Global' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  paymentTermsOptions: [
    { key: 'weekly', label: 'Weekly' },
    { key: 'bi_weekly', label: 'Bi-weekly' },
    { key: 'net_30', label: 'Net 30' },
    { key: 'net_45', label: 'Net 45' },
    { key: 'net_60', label: 'Net 60' },
    { key: 'net_90', label: 'Net 90' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  agencyTypeOptions: [
    { key: 'staffingProvider', label: 'Staffing Services' },
    { key: 'implementationService', label: 'Implementation Service' },
    { key: 'staffingAndImplementationServices', label: 'Staffing and Implementation Services' },
  ],

  customerTypeOptions: [
    { key: 'lookingForStaffingProvider', label: 'Looking for Staffing Provider' },
    { key: 'lookingForImplementationService', label: 'Looking for Implementation Service' },
    { key: 'lookingForStaffingProviderAndImplementationService', label: 'Looking for Staffing Provider and Implementation Service' },
  ],

  taxIdentificationTypeOptions: [
    { key: 'EIN (Employer Identification Number)', label: 'EIN (Employer Identification Number)' },
    {
      key: 'SSN / ITIN (Social Security or Taxpayer ID)',
      label: 'SSN / ITIN (Social Security or Taxpayer ID)',
    },
    { key: 'Foreign Tax ID', label: 'Foreign Tax ID' },
  ],

  taxClassificationTypeOptions: [
    { key: 'Individaul/Sole Proprietor', label: 'Individaul/Sole Proprietor' },
    { key: 'C Corporation', label: 'C Corporation' },
    { key: 'S Corporation', label: 'S Corporation' },
    { key: 'Partnership', label: 'Partnership' },
    { key: 'Trust/Estate or LLC', label: 'Trust/Estate or LLC' },
  ],

  employeeCountOptions: [
    { key: '1-10', label: '1-10' },
    { key: '11-50', label: '11-50' },
    { key: '51-200', label: '51-200' },
    { key: '201-500', label: '201-500' },
    { key: '500+', label: '500+' },
  ],

  revenueOptions: [
    { key: 'underMillion', label: 'Under $1M' },
    { key: 'oneToFive', label: '$1M - $5M' },
    { key: 'fiveToTwentyFive', label: '$5M - $25M' },
    { key: 'twentyFiveToHundres', label: '$25M-$100M' },
    { key: 'aboveHundred', label: '$100M+' },
  ],

  deliveryModelsOptions: [
    { key: 'Onsite', label: 'Onsite' },
    { key: 'Offsite', label: 'Offsite' },
    { key: 'Offshore', label: 'Offshore' },
    { key: 'Hybrid', label: 'Hybrid' },
  ],

  staffingServicesOfferedOptions: [
    { key: 'iTStaffAugmentation', label: 'IT Staff Augmentation' },
    { key: 'fullTimeRecruitment', label: 'Full-time Recruitment' },
    { key: 'governmentClearedTalent', label: 'Government-Cleared Talent' },
    { key: 'offshoreNearshoreTalent', label: 'Offshore/Nearshore Talent' },
    { key: 'vMSMSPPartnerships', label: 'VMS/MSP Partnerships' },
    // { key: 'benchC2CDeployment', label: 'Bench/C2C Deployment' },
    { key: 'C2CDeployment', label: 'C2C Deployment' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  typeOfBusinessOptions: [
    { key: 'sole_proprietorship', label: 'Sole Proprietorship' },
    { key: 'partnership', label: 'Partnership' },
    { key: 'llc', label: 'LLC (Limited Liability Company)' },
    { key: 'corporation_c', label: 'Corporation (C-Corp)' },
    { key: 's_corporation', label: 'S Corporation (S-Corp)' },
    { key: 'nonprofit', label: 'Nonprofit' },
    { key: 'cooperative', label: 'Cooperative' },
  ],

  certificationsOrDesignationsOptions: [
    { key: 'MinorityOwned', label: 'Minority-Owned' },
    { key: 'WomanOwned', label: 'Woman-Owned' },
    { key: 'VeteranOwned', label: 'Veteran-Owned' },
    { key: 'SBA8(a)', label: 'SBA 8(a)' },
    { key: 'ISO9001', label: 'ISO 9001' },
    { key: 'CMMILevel3', label: 'CMMI Level 3+' },
    { key: 'NMSDC', label: 'NMSDC' },
    // { key: 'Other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  certificationsOptions: [
    { key: 'MinorityOwned', label: 'Minority-Owned' },
    { key: 'WomanOwned', label: 'Woman-Owned' },
    { key: 'VeteranOwned', label: 'Veteran-Owned' },
    { key: 'SBA8(a)', label: 'SBA 8(a)' },
    { key: 'ISO9001', label: 'ISO 9001' },
    { key: 'CMMILevel3', label: 'CMMI Level 3+' },
    { key: 'NMSDC', label: 'NMSDC' },
    // { key: 'Other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  techForSpecOptions: [
    { key: 'react', label: 'React' },
    { key: 'angular', label: 'Angular' },
    { key: 'SAP', label: 'SAP' },
    { key: 'AWS', label: 'AWS' },
    { key: 'Salesforce', label: 'Salesforce' },
    { key: 'Sailpoint', label: 'Sailpoint' },
    { key: 'Azure', label: 'Azure' },
    { key: 'GCP', label: 'GCP' },
    { key: 'Workday', label: 'Workday' },
    { key: 'ServiceNow', label: 'ServiceNow' },
    { key: 'Oracle', label: 'Oracle' },
    { key: 'Microsoft Dynamics', label: 'Microsoft Dynamics' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  // Helper functions to get technologies for selected service domains
  getTechnologiesForServiceDomains: (selectedDomainKeys, allOptions = null) => {
    const technologyMapping = fieldOptions.serviceDomainTechnologyMapping;

    if (!selectedDomainKeys || !Array.isArray(selectedDomainKeys)) {
      return [];
    }

    const allTechnologies = new Set();

    // Add technologies from static configuration
    selectedDomainKeys.forEach(domainKey => {
      // Find the domain option by label and get its key
      const domainOption = fieldOptions.getServiceDomainByKey(domainKey);
      if (domainOption && domainOption.key) {
        const technologies = technologyMapping[domainOption.key];
        if (technologies && Array.isArray(technologies)) {
          technologies.forEach(tech => allTechnologies.add(tech));
        }
      }
    });

    // Add technologies from database (dynamic options) if allOptions is provided
    if (allOptions) {
      const techImpSpecOptions = allOptions.implementationTechFocSpecOptions || [];
      const techStaffSpecOptions = allOptions.staffingTechFocSpecOptions || [];

      // For implementation technology options
      techImpSpecOptions.forEach(tech => {
        // Check if this technology matches the selected service domains
        if (fieldOptions.matchesServiceDomains(tech, selectedDomainKeys)) {
          allTechnologies.add(tech.label);
        }
      });

      // For staffing technology options
      techStaffSpecOptions.forEach(tech => {
        // Check if this technology matches the selected service domains
        if (fieldOptions.matchesServiceDomains(tech, selectedDomainKeys)) {
          allTechnologies.add(tech.label);
        }
      });
    }

    return Array.from(allTechnologies).sort();
  },

  // Helper method to check if a technology matches the selected service domains
  matchesServiceDomains: (tech, selectedDomainKeys) => {
    // If no parentDomains specified, exclude it (require explicit domain matching)
    if (!tech.parentDomains || tech.parentDomains.length === 0) {
      return false;
    }

    // Check if any of the technology's parent domains match the selected domains
    const matches = selectedDomainKeys.some(domain => tech.parentDomains.includes(domain));
    // Debug: Uncomment to see matching logic in action
    // if (tech.label === 'o') {
    //   console.log('Tech:', tech.label, 'Parent Domains:', tech.parentDomains, 'Selected:', selectedDomainKeys, 'Matches:', matches);
    // }
    return matches;
  },

  getServiceDomainByKey: (key) => {
    const allDomains = [
      // ...fieldOptions.implementationServiceDomainsOptions,
      // ...fieldOptions.staffingServiceDomainsOptions,
      ...fieldOptions.serviceDomainsOptions,
    ];

    return allDomains.find(domain => domain.label === key);
  },

  techStaffNeedsOptions: [
    { key: 'react', label: 'React' },
    { key: 'angular', label: 'Angular' },
    { key: 'SAP', label: 'SAP' },
    { key: 'AWS', label: 'AWS' },
    { key: 'Salesforce', label: 'Salesforce' },
    { key: 'Sailpoint', label: 'Sailpoint' },
    { key: 'Azure', label: 'Azure' },
    { key: 'GCP', label: 'GCP' },
    { key: 'Workday', label: 'Workday' },
    { key: 'ServiceNow', label: 'ServiceNow' },
    { key: 'Oracle', label: 'Oracle' },
    { key: 'Microsoft Dynamics', label: 'Microsoft Dynamics' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  techImpNeedsOptions: [
    { key: 'react', label: 'React' },
    { key: 'angular', label: 'Angular' },
    { key: 'AWS', label: 'AWS' },
    { key: 'Salesforce', label: 'Salesforce' },
    { key: 'Sailpoint', label: 'Sailpoint' },
    { key: 'Azure', label: 'Azure' },
    { key: 'GCP', label: 'GCP' },
    { key: 'Workday', label: 'Workday' },
    { key: 'ServiceNow', label: 'ServiceNow' },
    { key: 'Oracle', label: 'Oracle' },
    { key: 'Microsoft Dynamics', label: 'Microsoft Dynamics' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  tagsOptions: [
    { key: 'frontend_developer', label: 'Frontend Developer' },
    { key: 'software_engineer', label: 'Software Engineer' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  staffRoleNeedsOptions: [
    { key: 'frontend_developer', label: 'Frontend Developer' },
    { key: 'software_engineer', label: 'Software Engineer' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  companyTypeOptions: [ // not using anywhere
    { key: 'corporation', label: 'Corporation' },
    { key: 'llc', label: 'Limited Liability Company (LLC)' },
    { key: 'partnership', label: 'Partnership' },
    { key: 'sole_proprietorship', label: 'Sole Proprietorship' },
    { key: 'nonprofit', label: 'Non-profit Organization' },
    { key: 'government', label: 'Government Agency' },
    // { key: 'other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  industryFocusOptions: [
    { key: 'technology', label: 'Technology' },
    { key: 'healthcare', label: 'Healthcare' },
    { key: 'finance', label: 'Finance & Banking' },
    { key: 'manufacturing', label: 'Manufacturing' },
    { key: 'retail', label: 'Retail' },
    { key: 'education', label: 'Education' },
    { key: 'government', label: 'Government' },
    { key: 'energy', label: 'Energy & Utilities' },
    { key: 'construction', label: 'Construction' },
    { key: 'transportation', label: 'Transportation & Logistics' },
    { key: 'hospitality', label: 'Hospitality & Tourism' },
    { key: 'media', label: 'Media & Entertainment' },
    { key: 'real_estate', label: 'Real Estate' },
    { key: 'legal', label: 'Legal Services' },
    { key: 'consulting', label: 'Consulting' },
    { key: 'Public Sector', label: 'Public Sector' },
    // { key: 'other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  geographicCoverageOptions: [
    { key: 'local', label: 'Local' },
    { key: 'regional', label: 'Regional' },
    { key: 'national', label: 'National' },
    { key: 'international', label: 'International' },
  ],

  clientTypesOptions: [
    { key: 'small_business', label: 'Small Businesses' },
    { key: 'mid_market', label: 'Mid-Market Companies' },
    { key: 'enterprise', label: 'Enterprise Organizations' },
    { key: 'government', label: 'Government Agencies' },
    { key: 'nonprofit', label: 'Non-profit Organizations' },
    { key: 'startups', label: 'Startups' },
  ],

  contractorAvailabilityOptions: [
    { key: 'immediate', label: 'Immediate' },
    { key: 'within_week', label: 'Within a week' },
    { key: 'within_month', label: 'Within a month' },
    { key: 'within_quarter', label: 'Within a quarter' },
    { key: 'not_available', label: 'Not currently available' },
  ],

  experienceLevelOptions: [
    { key: 'entry', label: 'Entry Level (0-2 years)' },
    { key: 'mid', label: 'Mid Level (3-5 years)' },
    { key: 'senior', label: 'Senior Level (6-10 years)' },
    { key: 'expert', label: 'Expert Level (10+ years)' },
  ],

  securityClearanceOptions: [
    { key: 'none', label: 'No Clearance' },
    { key: 'confidential', label: 'Confidential' },
    { key: 'secret', label: 'Secret' },
    { key: 'top_secret', label: 'Top Secret' },
    { key: 'ts_sci', label: 'Top Secret/SCI' },
  ],

  educationLevelOptions: [  // not using anywhere
    { key: 'high_school', label: 'High School Diploma/GED' },
    { key: 'associates', label: 'Associate Degree' },
    { key: 'bachelors', label: "Bachelor's Degree" },
    { key: 'masters', label: "Master's Degree" },
    { key: 'doctorate', label: 'Doctorate/PhD' },
    { key: 'professional', label: 'Professional Degree' },
    { key: 'certification', label: 'Professional Certification' },
    // { key: 'other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  skillLevelOptions: [
    { key: 'beginner', label: 'Beginner' },
    { key: 'intermediate', label: 'Intermediate' },
    { key: 'advanced', label: 'Advanced' },
    { key: 'expert', label: 'Expert' },
  ],

  yearsOfExperienceOptions: [
    { key: '0-1', label: '0-1 years' },
    { key: '2-3', label: '2-3 years' },
    { key: '4-5', label: '4-5 years' },
    { key: '6-10', label: '6-10 years' },
    { key: '11-15', label: '11-15 years' },
    { key: '16-20', label: '16-20 years' },
    { key: '20+', label: '20+ years' },
  ],

  jobLevelOptions: [
    { key: 'entry', label: 'Entry Level' },
    { key: 'associate', label: 'Associate' },
    { key: 'mid', label: 'Mid Level' },
    { key: 'senior', label: 'Senior Level' },
    { key: 'lead', label: 'Lead' },
    { key: 'principal', label: 'Principal' },
    { key: 'manager', label: 'Manager' },
    { key: 'director', label: 'Director' },
    { key: 'vp', label: 'Vice President' },
    { key: 'c_level', label: 'C-Level Executive' },
  ],

  employmentTypeOptions: [
    { key: 'full_time', label: 'Full-time' },
    { key: 'part_time', label: 'Part-time' },
    { key: 'contract', label: 'Contract' },
    { key: 'temporary', label: 'Temporary' },
    { key: 'internship', label: 'Internship' },
    { key: 'freelance', label: 'Freelance' },
  ],

  salaryRangeOptions: [
    { key: 'under_40k', label: 'Under $40,000' },
    { key: '40k_60k', label: '$40,000 - $60,000' },
    { key: '60k_80k', label: '$60,000 - $80,000' },
    { key: '80k_100k', label: '$80,000 - $100,000' },
    { key: '100k_120k', label: '$100,000 - $120,000' },
    { key: '120k_150k', label: '$120,000 - $150,000' },
    { key: '150k_200k', label: '$150,000 - $200,000' },
    { key: 'over_200k', label: 'Over $200,000' },
  ],

  hourlyRateOptions: [
    { key: 'under_25', label: 'Under $25/hour' },
    { key: '25_40', label: '$25 - $40/hour' },
    { key: '40_60', label: '$40 - $60/hour' },
    { key: '60_80', label: '$60 - $80/hour' },
    { key: '80_100', label: '$80 - $100/hour' },
    { key: '100_150', label: '$100 - $150/hour' },
    { key: 'over_150', label: 'Over $150/hour' },
  ],

  travelRequirementsOptions: [
    { key: 'none', label: 'No Travel' },
    { key: 'minimal', label: 'Minimal (0-10%)' },
    { key: 'occasional', label: 'Occasional (10-25%)' },
    { key: 'frequent', label: 'Frequent (25-50%)' },
    { key: 'extensive', label: 'Extensive (50%+)' },
  ],

  workScheduleOptions: [
    { key: 'standard', label: 'Standard (9 AM - 5 PM)' },
    { key: 'flexible', label: 'Flexible Hours' },
    { key: 'evening', label: 'Evening Shift' },
    { key: 'night', label: 'Night Shift' },
    { key: 'weekend', label: 'Weekend Work' },
    { key: 'rotating', label: 'Rotating Shifts' },
    { key: '24_7', label: '24/7 Availability' },
  ],

  benefitsOfferedOptions: [
    { key: 'health_insurance', label: 'Health Insurance' },
    { key: 'dental_insurance', label: 'Dental Insurance' },
    { key: 'vision_insurance', label: 'Vision Insurance' },
    { key: '401k', label: '401(k) Retirement Plan' },
    { key: 'paid_time_off', label: 'Paid Time Off' },
    { key: 'paid_holidays', label: 'Paid Holidays' },
    { key: 'life_insurance', label: 'Life Insurance' },
    { key: 'disability_insurance', label: 'Disability Insurance' },
    { key: 'flexible_schedule', label: 'Flexible Schedule' },
    { key: 'remote_work', label: 'Remote Work Options' },
    { key: 'professional_development', label: 'Professional Development' },
    { key: 'tuition_reimbursement', label: 'Tuition Reimbursement' },
  ],

  companySetupStatusOptions: [
    { key: 'complete', label: 'Complete' },
    { key: 'in_progress', label: 'In Progress' },
    { key: 'not_started', label: 'Not Started' },
  ],

  verificationStatusOptions: [
    { key: 'verified', label: 'Verified' },
    { key: 'pending', label: 'Pending Verification' },
    { key: 'not_verified', label: 'Not Verified' },
    { key: 'failed', label: 'Verification Failed' },
  ],

  documentStatusOptions: [
    { key: 'uploaded', label: 'Uploaded' },
    { key: 'pending', label: 'Pending Review' },
    { key: 'approved', label: 'Approved' },
    { key: 'rejected', label: 'Rejected' },
    { key: 'expired', label: 'Expired' },
  ],

  communicationPreferencesOptions: [
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Phone' },
    { key: 'text', label: 'Text Message' },
    { key: 'platform', label: 'Platform Messaging' },
  ],

  notificationPreferencesOptions: [
    { key: 'all', label: 'All Notifications' },
    { key: 'important', label: 'Important Only' },
    { key: 'minimal', label: 'Minimal' },
    { key: 'none', label: 'None' },
  ],

  timezoneOptions: [
    { key: 'EST', label: 'Eastern Time (EST/EDT)' },
    { key: 'CST', label: 'Central Time (CST/CDT)' },
    { key: 'MST', label: 'Mountain Time (MST/MDT)' },
    { key: 'PST', label: 'Pacific Time (PST/PDT)' },
    { key: 'AKST', label: 'Alaska Time (AKST/AKDT)' },
    { key: 'HST', label: 'Hawaii Time (HST)' },
  ],

  // ProfileOnboardingForm specific options
  supportedContractTypesOptions: [
    { key: 'W2', label: 'W2' },
    { key: 'C2C', label: 'C2C' },
    { key: '1099', label: '1099' },
    { key: 'DirectHire', label: 'Direct Hire' },
    { key: 'ContractToHire', label: 'Contract-to-Hire' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  projectTypesDeliveredOptions: [
    { key: 'fixedFee', label: 'Fixed Fee' },
    { key: 'timeAndMaterials', label: 'Time & Materials' },
    { key: 'milestoneBased', label: 'Milestone-Based' },
  ],

  // Technology mapping for service domains
  serviceDomainTechnologyMapping: {
    'ai_llm_apis_stacks': [
      'OpenAI API', 'Azure OpenAI Service', 'Anthropic Claude', 'Google Gemini',
      'Cohere', 'Hugging Face Inference', 'NVIDIA NIM/NeMo', 'LlamaStack'
    ],
    'ai_arvr_xr': [
      'Unity', 'Unreal Engine', 'Microsoft HoloLens', 'Meta Quest', 'Apple visionOS/RealityKit'
    ],
    'ai_computer_vision': [
      'OpenCV', 'Detectron2', 'YOLOv5/v8', 'TensorRT', 'AWS Rekognition',
      'Google Vision AI', 'Azure Computer Vision'
    ],
    'ai_iot_platforms': [
      'AWS IoT Core', 'Azure IoT Hub', 'PTC ThingWorx', 'Siemens MindSphere',
      'IBM Watson IoT', 'HiveMQ', 'Losant'
    ],
    'ai_ml_platforms_mlops': [
      'AWS SageMaker', 'Google Vertex AI', 'Azure Machine Learning', 'Databricks MLflow',
      'Kubeflow', 'DataRobot', 'H2O.ai', 'Domino Data Lab', 'Neptune.ai', 'Weights & Biases'
    ],
    'ai_nlp_libraries': [
      'spaCy', 'NLTK', 'Hugging Face Transformers', 'OpenNLP', 'Gensim', 'Rasa'
    ],
    'ai_rag_frameworks_eval': [
      'LangChain', 'LlamaIndex', 'Haystack', 'TruLens', 'Promptfoo', 'DeepEval', 'Phoenix (Arize)'
    ],
    'ai_rpa_automation': [
      'UiPath', 'Automation Anywhere', 'Blue Prism', 'Microsoft Power Automate',
      'AutomationEdge', 'Nintex', 'WorkFusion'
    ],
    'ai_vector_databases': [
      'Pinecone', 'Weaviate', 'Milvus', 'Qdrant', 'Chroma', 'Redis (Vector)',
      'pgvector/PostgreSQL', 'FAISS', 'Elasticsearch/OpenSearch (kNN)', 'Vespa', 'ClickHouse', 'LanceDB', 'KDB.AI'
    ],
    'cloud_api_management': [
      'Google Apigee', 'Microsoft Azure API Management', 'Amazon API Gateway', 'Kong Konnect',
      'Tyk', 'WSO2 API Manager', 'IBM API Connect', 'MuleSoft Anypoint', 'Axway Amplify',
      'Gravitee', 'NGINX API Connectivity Manager', 'Broadcom Layer7'
    ],
    'cloud_artifact_repositories': [
      'JFrog Artifactory', 'Sonatype Nexus', 'GitHub Packages', 'GitLab Package Registry',
      'Azure Artifacts', 'AWS CodeArtifact'
    ],
    'cloud_backup_draas': [
      'Veeam', 'Commvault', 'Rubrik', 'Cohesity', 'Zerto', 'Acronis', 'Druva',
      'Datto', 'IBM Spectrum Protect', 'Microsoft Azure Site Recovery', 'AWS Backup', 'iland', 'TierPoint', 'Expedient'
    ],
    'cloud_feature_flags': [
      'LaunchDarkly', 'Split.io', 'Optimizely Feature Experimentation', 'Flagsmith',
      'AB Tasty', 'CloudBees Feature Management'
    ],
    'cloud_finops': [
      'Apptio Cloudability', 'CloudHealth by VMware', 'Flexera One', 'AWS Cost Explorer/CCM',
      'Azure Cost Management', 'Google Cloud Billing', 'CloudZero', 'Finout', 'ProsperOps', 'Ternary'
    ],
    'cloud_incident_management': [
      'PagerDuty', 'Atlassian Opsgenie', 'Splunk On‑Call (VictorOps)', 'xMatters',
      'Better Stack', 'Incident.io', 'Squadcast'
    ],
    'cloud_service_mesh': [
      'Istio', 'Linkerd', 'Consul Service Mesh', 'Kuma', 'AWS App Mesh', 'Open Service Mesh'
    ],
    'cloud_platforms': [
      'Amazon Web Services (AWS)', 'Microsoft Azure', 'Google Cloud Platform (GCP)',
      'Oracle Cloud Infrastructure (OCI)', 'IBM Cloud', 'Alibaba Cloud', 'DigitalOcean'
    ],
    'cloud_containerization': [
      'Docker', 'Kubernetes', 'Red Hat OpenShift', 'Rancher', 'VMware Tanzu',
      'Nomad', 'Amazon EKS', 'Azure Kubernetes Service (AKS)', 'Google Kubernetes Engine (GKE)'
    ],
    'cloud_devops_cicd': [
      'Jenkins', 'GitHub Actions', 'GitLab CI/CD', 'CircleCI', 'Azure DevOps Pipelines',
      'Travis CI', 'TeamCity', 'Bamboo', 'Argo CD', 'Flux CD', 'Spinnaker', 'Harness'
    ],
    'cloud_infra_iaas': [
      'HashiCorp Terraform', 'OpenTofu', 'Pulumi', 'AWS CloudFormation',
      'Azure Resource Manager (ARM/Bicep)', 'Google Cloud Deployment Manager', 'Ansible',
      'Chef', 'Puppet', 'SaltStack', 'Crossplane', 'AWS CDK', 'Terragrunt', 'Vagrant'
    ],
    'cloud_networking': [
      'Cisco IOS‑XE/NX‑OS', 'Juniper Junos', 'Aruba', 'F5 BIG‑IP', 'Citrix NetScaler (ADC)',
      'Cloudflare', 'Akamai', 'Fastly', 'NGINX Plus', 'HAProxy'
    ],
    'cloud_virtualization': [
      'VMware vSphere/ESXi', 'VMware vSAN', 'Microsoft Hyper‑V', 'Citrix Virtual Apps & Desktops',
      'VMware Horizon', 'Nutanix AHV/Prism', 'Parallels RAS'
    ],
    'cyber_casb_sse': [
      'Netskope', 'Skyhigh Security', 'Zscaler', 'Palo Alto Prisma Access',
      'Microsoft Defender for Cloud Apps', 'Cisco Cloudlock', 'Forcepoint ONE', 'Lookout CASB'
    ],
    'cyber_ciem': [
      'Wiz', 'Sonrai Security', 'Ermetic', 'Veza', 'Microsoft Entra Permissions Mgmt (CloudKnox)',
      'Zscaler CIEM', 'Palo Alto Prisma Cloud CIEM', 'Securiti'
    ],
    'cyber_cloud_security': [
      'Palo Alto Prisma Cloud', 'Wiz', 'Lacework', 'Orca Security', 'Check Point CloudGuard',
      'Aqua Security', 'Sysdig Secure', 'Snyk', 'Tenable', 'Qualys'
    ],
    'cyber_cnapp': [
      'Palo Alto Prisma Cloud', 'Wiz', 'Lacework', 'Orca Security', 'Microsoft Defender for Cloud',
      'Check Point CloudGuard', 'Aqua Security', 'Sysdig Secure'
    ],
    'cyber_dlp': [
      'Symantec DLP (Broadcom)', 'Forcepoint DLP', 'Proofpoint Enterprise DLP',
      'Microsoft Purview DLP', 'Trellix (McAfee) DLP', 'Digital Guardian',
      'GTB Technologies', 'Endpoint Protector (CoSoSys)'
    ],
    'cyber_data_protection': [
      'Veeam', 'Commvault', 'Rubrik', 'Cohesity', 'Veritas NetBackup',
      'Thales CipherTrust', 'Delinea PAM', 'HashiCorp Vault'
    ],
    'cyber_dspm': [
      'Varonis', 'Wiz DSPM', 'BigID', 'Sentra', 'Cyera', 'Lookout',
      'Dig Security', 'Symmetry Systems'
    ],
    'cyber_email_security': [
      'Proofpoint Email Protection', 'Microsoft Defender for Office 365', 'Mimecast',
      'Barracuda Email Security', 'Cisco Secure Email', 'Tessian', 'Abnormal Security', 'Sophos Email'
    ],
    'cyber_endpoint_management': [
      'Microsoft Intune', 'Omnissa Workspace ONE UEM', 'IBM Security MaaS360',
      'Ivanti Neurons for UEM', 'Jamf Pro', 'Hexnode UEM', 'ManageEngine Endpoint Central', 'Kandji'
    ],
    'cyber_endpoint_edr': [
      'CrowdStrike Falcon', 'Microsoft Defender for Endpoint', 'SentinelOne',
      'Trellix Endpoint Security', 'Sophos Intercept X', 'Trend Micro Vision One',
      'Bitdefender GravityZone', 'VMware Carbon Black', 'Cybereason'
    ],
    'cyber_iam': [
      'Okta', 'Auth0', 'Microsoft Entra ID (Azure AD)', 'Ping Identity', 'ForgeRock',
      'OneLogin', 'IBM Security Verify', 'AWS IAM', 'Google Cloud Identity'
    ],
    'cyber_iga': [
      'SailPoint Identity Security Cloud', 'Saviynt IGA', 'Oracle Identity Governance',
      'IBM Security Verify Governance', 'Microsoft Entra ID Governance', 'One Identity Manager',
      'Omada Identity', 'SAP Identity Management'
    ],
    'cyber_itam': [
      'Flexera One', 'Snow License Manager', 'ServiceNow ITAM/SAM', 'Ivanti Neurons for ITAM',
      'Certero', 'USU', 'LeanIX', 'Lansweeper'
    ],
    'cyber_network_security': [
      'Palo Alto Networks', 'Fortinet FortiGate', 'Check Point Quantum', 'Cisco Secure Firewall',
      'Juniper SRX', 'SonicWall'
    ],
    'cyber_pki': [
      'Venafi', 'DigiCert Trust Lifecycle Manager', 'AppViewX CERT+', 'Sectigo Certificate Manager',
      'Keyfactor', 'ManageEngine Key Manager Plus'
    ],
    'cyber_pam': [
      'CyberArk Privileged Access Manager', 'Delinea Secret Server', 'BeyondTrust Privileged Access',
      'One Identity Safeguard', 'WALLIX Bastion', 'Senhasegura', 'ARCON PAM', 'ManageEngine PAM360'
    ],
    'cyber_secrets_management': [
      'HashiCorp Vault', 'AWS KMS', 'Azure Key Vault', 'Google Cloud KMS',
      'CyberArk Conjur', 'Akeyless', 'Doppler', '1Password Secrets Automation'
    ],
    'cyber_siem_soar': [
      'Splunk Enterprise Security', 'IBM QRadar', 'Microsoft Sentinel', 'Exabeam',
      'Securonix', 'LogRhythm', 'Elastic SIEM', 'Devo', 'Trellix Helix',
      'Graylog', 'Google Chronicle'
    ],
    'cyber_ztna': [
      'Zscaler ZPA/ZIA', 'Palo Alto Prisma Access', 'Netskope Private Access',
      'Cloudflare Zero Trust', 'Cisco Secure Access', 'Fortinet FortiSASE',
      'Perimeter 81', 'AppGate SDP'
    ],
    'data_bi': [
      'Microsoft Power BI', 'Tableau', 'Qlik Sense', 'Looker', 'SAP BusinessObjects',
      'MicroStrategy', 'Domo', 'Sisense', 'TIBCO Spotfire', 'IBM Cognos Analytics',
      'Amazon QuickSight', 'Oracle Analytics Cloud'
    ],
    'data_bigdata': [
      'Apache Hadoop', 'Apache Spark', 'Apache Flink', 'Apache Kafka', 'Confluent Platform',
      'Cloudera Data Platform', 'Hortonworks (legacy)', 'Apache Hive', 'PrestoSQL/Trino', 'Apache HBase'
    ],
    'data_catalog': [
      'Collibra', 'Alation', 'Informatica Data Catalog', 'Ataccama ONE',
      'IBM Watson Knowledge Catalog', 'Microsoft Purview', 'Google Data Catalog'
    ],
    'data_lineage': [
      'Manta', 'Solidatus', 'Collibra Data Lineage', 'Atlan', 'Monte Carlo',
      'Bigeye', 'Databand'
    ],
    'data_warehouse': [
      'Snowflake', 'Google BigQuery', 'Amazon Redshift', 'Azure Synapse Analytics',
      'Databricks Lakehouse', 'Teradata Vantage', 'IBM Db2 Warehouse',
      'Oracle Autonomous Data Warehouse', 'Firebolt', 'Starburst (Trino)', 'Dremio'
    ],
    'data_nosql': [
      'MongoDB', 'Cassandra', 'Couchbase', 'Redis Enterprise', 'Amazon DynamoDB',
      'Azure Cosmos DB', 'Neo4j', 'ArangoDB', 'Elasticsearch', 'OpenSearch',
      'InfluxDB', 'TimescaleDB'
    ],
    'data_relational': [
      'Oracle Database', 'Microsoft SQL Server', 'MySQL', 'PostgreSQL', 'MariaDB',
      'IBM Db2', 'SAP HANA', 'Amazon Aurora', 'Google Cloud SQL', 'Azure SQL Database',
      'Teradata Vantage', 'Vertica'
    ],
    'data_etl': [
      'Informatica IDMC/PowerCenter', 'Talend/Qlik Data Integration', 'MuleSoft Anypoint Platform',
      'Boomi', 'SnapLogic', 'Workato', 'Matillion', 'Fivetran', 'Stitch', 'Airbyte',
      'Hevo Data', 'AWS Glue', 'Azure Data Factory', 'Google Cloud Dataflow',
      'Apache NiFi', 'Pentaho Data Integration (Kettle)'
    ],
    'data_feature_store': [
      'Tecton', 'Feast', 'Databricks Feature Store', 'Hopsworks',
      'AWS SageMaker Feature Store', 'Google Vertex AI Feature Store'
    ],
    'data_mdm': [
      'Informatica MDM', 'Reltio', 'Semarchy xDM', 'SAP Master Data Governance',
      'IBM InfoSphere MDM', 'Oracle Enterprise Data Quality', 'Talend Data Quality',
      'Ataccama ONE', 'Collibra', 'Alation'
    ],
    'data_observability': [
      'Datadog', 'New Relic', 'Dynatrace', 'Splunk Observability', 'Elastic Observability',
      'Grafana', 'Prometheus', 'Zabbix', 'AppDynamics'
    ],
    'data_reverse_etl': [
      'Hightouch', 'Census', 'RudderStack', 'Workato', 'Polytomic',
      'Rivery', 'Hevo Activate', 'Dataddo'
    ],
    'digital_collaboration': [
      'Microsoft 365', 'Google Workspace', 'Slack', 'Zoom', 'Webex',
      'Notion', 'Atlassian Confluence', 'Dropbox', 'Box'
    ],
    'digital_cdp': [
      'Twilio Segment', 'mParticle', 'Tealium AudienceStream', 'Amperity',
      'Adobe Real‑Time CDP', 'Salesforce Data Cloud', 'Treasure Data',
      'BlueConic', 'RudderStack CDP'
    ],
    'digital_ecommerce': [
      'Adobe Commerce (Magento)', 'Shopify', 'BigCommerce', 'Salesforce Commerce Cloud',
      'SAP Commerce Cloud (Hybris)', 'WooCommerce', 'commercetools', 'VTEX', 'Elastic Path'
    ],
    'digital_experimentation': [
      'Optimizely', 'Adobe Target', 'VWO', 'Dynamic Yield', 'Kameleoon'
    ],
    'digital_headless_cms': [
      'Contentful', 'Contentstack', 'Sanity', 'Strapi', 'Storyblok',
      'Kontent.ai', 'Prismic', 'Hygraph', 'Agility CMS', 'Ghost',
      'ButterCMS', 'Decap (Netlify CMS)'
    ],
    'digital_marketing': [
      'Adobe Marketo', 'Salesforce Marketing Cloud', 'HubSpot Marketing Hub',
      'Oracle Eloqua', 'Pardot (Account Engagement)', 'Braze', 'Iterable',
      'Twilio Segment', 'Tealium AudienceStream'
    ],
    'digital_web_cms': [
      'Adobe Experience Manager', 'Sitecore', 'Optimizely', 'Acquia Drupal',
      'WordPress VIP', 'Magnolia CMS', 'Liferay DXP'
    ],
    'enterprise_crm': [
      'Salesforce Sales Cloud', 'Salesforce Service Cloud', 'Salesforce Marketing Cloud',
      'Microsoft Dynamics 365 Sales', 'Microsoft Dynamics 365 Customer Service',
      'Oracle CX Sales', 'SAP Sales Cloud', 'HubSpot CRM', 'Zoho CRM',
      'Pega Customer Service', 'SugarCRM', 'Freshsales', 'Creatio CRM',
      'Zendesk', 'Salesforce Commerce/Experience Cloud (B2B)'
    ],
    'enterprise_customer_service': [
      'ServiceNow', 'Atlassian Jira Service Management', 'BMC Helix/Remedy',
      'Freshservice', 'Zendesk Suite', 'ManageEngine ServiceDesk Plus'
    ],
    'enterprise_erp': [
      'SAP S/4HANA', 'SAP ECC', 'Oracle E‑Business Suite', 'Oracle NetSuite',
      'Microsoft Dynamics 365 Finance & Operations', 'Infor CloudSuite', 'Workday Financials',
      'Sage Intacct', 'Epicor Kinetic', 'IFS Cloud', 'Acumatica', 'Odoo', 'Unit4 ERP',
      'Deltek Costpoint', 'SYSPRO', 'QAD Adaptive ERP', 'Plex Smart Manufacturing Platform', 'Priority ERP'
    ],
    'enterprise_finance': [
      'Oracle Fusion Cloud EPM', 'Anaplan', 'Workday Adaptive Planning',
      'SAP BPC/Group Reporting', 'OneStream', 'Planful', 'Board', 'Prophix'
    ],
    'enterprise_hcm': [
      'Workday HCM', 'SAP SuccessFactors', 'Oracle HCM Cloud', 'UKG Pro',
      'ADP Workforce Now', 'Ceridian Dayforce', 'BambooHR', 'Paycom',
      'Rippling', 'Gusto', 'Namely', 'Zoho People'
    ],
    'enterprise_supply_chain': [
      'SAP Ariba', 'Coupa', 'Oracle SCM Cloud', 'Jaggaer', 'Ivalua',
      'GEP SMART', 'Manhattan Active', 'Blue Yonder', 'E2open', 'Kinaxis',
      'Infor Supply Chain', 'o9 Solutions'
    ],
    'industry_banking': [
      'Temenos', 'Finacle', 'FIS', 'Fiserv', 'Thought Machine', 'Mambu', 'Avaloq'
    ],
    'industry_healthcare': [
      'Epic', 'Oracle Health (Cerner)', 'Altera (Allscripts)', 'Meditech', 'athenahealth'
    ],
    'industry_highered': [
      'Ellucian Banner/Colleague', 'Oracle PeopleSoft Campus Solutions', 'Workday Student',
      'Anthology', 'Jenzabar', 'Unit4 Student Management'
    ],
    'industry_insurance': [
      'Guidewire InsuranceSuite', 'Duck Creek Suite', 'Sapiens IDIT/CoreSuite',
      'Insurity', 'Majesco', 'OneShield', 'BriteCore', 'EIS Suite'
    ],
    'industry_manufacturing': [
      'Siemens Teamcenter', 'Dassault 3DEXPERIENCE', 'PTC Windchill',
      'SAP PLM', 'Siemens Opcenter MES', 'Rockwell FactoryTalk', 'GE Proficy'
    ],
    'industry_public_sector': [
      'Tyler Technologies Enterprise ERP/Munis', 'Oracle PeopleSoft', 'Workday',
      'Unit4 ERP', 'Microsoft Dynamics 365 for Government'
    ],
    'industry_retail': [
      'Oracle Retail', 'Microsoft Dynamics 365 Commerce', 'NCR', 'Lightspeed', 'Square'
    ],
    'industry_telecom': [
      'Amdocs', 'Ericsson Digital BSS', 'Nokia NetAct', 'Netcracker', 'MATRIXX Software'
    ],
    'itops_aiops': [
      'Dynatrace', 'BigPanda', 'Moogsoft', 'Datadog AIOps', 'IBM Cloud Pak for AIOps',
      'OpsRamp', 'New Relic AIOps'
    ],
    'itops_apm': [
      'Dynatrace', 'New Relic', 'Datadog APM', 'AppDynamics', 'Instana',
      'Elastic APM', 'Grafana Tempo/Loki', 'Sentry'
    ],
    'itops_itom': [
      'ServiceNow ITOM', 'BMC Helix Discovery', 'OpenText (Micro Focus) UCMDB', 'Device42'
    ],
    'itops_itsm': [
      'ServiceNow', 'Atlassian Jira Service Management', 'BMC Helix ITSM',
      'Ivanti Neurons for ITSM', 'Freshservice', 'ManageEngine ServiceDesk Plus',
      'EasyVista', 'Cherwell (OpenText)'
    ],
    'project_agile': [
      'Jira Software', 'Asana', 'Monday.com', 'Trello', 'ClickUp',
      'Wrike', 'Basecamp', 'Shortcut'
    ],
    'project_ppm': [
      'Microsoft Project', 'Planview', 'Clarity PPM', 'Smartsheet',
      'Workfront', 'Oracle Primavera P6'
    ],
    'software_frontend': [
      'React', 'Angular', 'Vue.js', 'Svelte', 'Next.js', 'Nuxt'
    ],
    'software_languages': [
      'Java', '.NET', 'Node.js', 'Python', 'Go', 'PHP',
      'Ruby', 'C/C++', 'Rust', 'Kotlin', 'Swift'
    ],
    'software_mobile': [
      'Swift/SwiftUI', 'Kotlin/Jetpack Compose', 'React Native',
      'Flutter', 'Xamarin/Maui', 'Ionic'
    ],
    'software_testing': [
      'Selenium', 'Cypress', 'Playwright', 'JUnit', 'TestNG',
      'NUnit', 'Jest', 'Mocha', 'PyTest', 'Postman', 'SoapUI', 'K6', 'JMeter'
    ],
    'software_web_backend': [
      'Spring Boot', '.NET Core/ASP.NET', 'Django', 'Flask', 'FastAPI',
      'Ruby on Rails', 'Express.js', 'NestJS'
    ]
  },

  // Service domains based on category-subdomain structure
  // implementationServiceDomainsOptions: [
  //   // AI & Emerging Tech
  //   { key: 'ai_llm_apis_stacks', label: 'AI & Emerging Tech - AI/LLM APIs & Stacks', category: 'AI & Emerging Tech', subdomain: 'AI/LLM APIs & Stacks' },
  //   { key: 'ai_arvr_xr', label: 'AI & Emerging Tech - AR/VR/XR', category: 'AI & Emerging Tech', subdomain: 'AR/VR/XR' },
  //   { key: 'ai_computer_vision', label: 'AI & Emerging Tech - Computer Vision', category: 'AI & Emerging Tech', subdomain: 'Computer Vision' },
  //   { key: 'ai_iot_platforms', label: 'AI & Emerging Tech - IoT Platforms', category: 'AI & Emerging Tech', subdomain: 'IoT Platforms' },
  //   { key: 'ai_ml_platforms_mlops', label: 'AI & Emerging Tech - ML Platforms & MLOps', category: 'AI & Emerging Tech', subdomain: 'ML Platforms & MLOps' },
  //   { key: 'ai_nlp_libraries', label: 'AI & Emerging Tech - NLP Libraries', category: 'AI & Emerging Tech', subdomain: 'NLP Libraries' },
  //   { key: 'ai_rag_frameworks_eval', label: 'AI & Emerging Tech - RAG Frameworks & Eval', category: 'AI & Emerging Tech', subdomain: 'RAG Frameworks & Eval' },
  //   { key: 'ai_rpa_automation', label: 'AI & Emerging Tech - RPA/Automation', category: 'AI & Emerging Tech', subdomain: 'RPA/Automation' },
  //   { key: 'ai_vector_databases', label: 'AI & Emerging Tech - Vector Databases', category: 'AI & Emerging Tech', subdomain: 'Vector Databases' },
  //   // Cloud & DevOps
  //   { key: 'cloud_api_management', label: 'Cloud & DevOps - API Management & Gateways', category: 'Cloud & DevOps', subdomain: 'API Management & Gateways' },
  //   { key: 'cloud_artifact_repositories', label: 'Cloud & DevOps - Artifact Repositories & Build', category: 'Cloud & DevOps', subdomain: 'Artifact Repositories & Build' },
  //   { key: 'cloud_backup_draas', label: 'Cloud & DevOps - Backup & DRaaS / BaaS', category: 'Cloud & DevOps', subdomain: 'Backup & DRaaS / BaaS' },
  //   { key: 'cloud_feature_flags', label: 'Cloud & DevOps - Feature Flags & Experimentation', category: 'Cloud & DevOps', subdomain: 'Feature Flags & Experimentation' },
  //   { key: 'cloud_finops', label: 'Cloud & DevOps - FinOps / Cloud Cost Management', category: 'Cloud & DevOps', subdomain: 'FinOps / Cloud Cost Management' },
  //   { key: 'cloud_incident_management', label: 'Cloud & DevOps - Incident & On‑Call Management', category: 'Cloud & DevOps', subdomain: 'Incident & On‑Call Management' },
  //   { key: 'cloud_service_mesh', label: 'Cloud & DevOps - Service Mesh', category: 'Cloud & DevOps', subdomain: 'Service Mesh' },
  //   // Cloud & Infrastructure
  //   { key: 'cloud_platforms', label: 'Cloud & Infrastructure - Cloud Platforms (IaaS/PaaS)', category: 'Cloud & Infrastructure', subdomain: 'Cloud Platforms (IaaS/PaaS)' },
  //   { key: 'cloud_containerization', label: 'Cloud & Infrastructure - Containerization & Orchestration', category: 'Cloud & Infrastructure', subdomain: 'Containerization & Orchestration' },
  //   { key: 'cloud_devops_cicd', label: 'Cloud & Infrastructure - DevOps & CI/CD', category: 'Cloud & Infrastructure', subdomain: 'DevOps & CI/CD' },
  //   { key: 'cloud_infra_iaas', label: 'Cloud & Infrastructure - Infrastructure as Code (IaC)', category: 'Cloud & Infrastructure', subdomain: 'Infrastructure as Code (IaC)' },
  //   { key: 'cloud_networking', label: 'Cloud & Infrastructure - Networking & CDN', category: 'Cloud & Infrastructure', subdomain: 'Networking & CDN' },
  //   { key: 'cloud_virtualization', label: 'Cloud & Infrastructure - Virtualization & VDI', category: 'Cloud & Infrastructure', subdomain: 'Virtualization & VDI' },
  //   // Cybersecurity
  //   { key: 'cyber_casb_sse', label: 'Cybersecurity - Cloud Access Security Broker (CASB) / SSE', category: 'Cybersecurity', subdomain: 'Cloud Access Security Broker (CASB) / SSE' },
  //   { key: 'cyber_ciem', label: 'Cybersecurity - Cloud Infra Entitlement Mgmt (CIEM)', category: 'Cybersecurity', subdomain: 'Cloud Infra Entitlement Mgmt (CIEM)' },
  //   { key: 'cyber_cloud_security', label: 'Cybersecurity - Cloud Security Posture/CNAPP', category: 'Cybersecurity', subdomain: 'Cloud Security Posture/CNAPP' },
  //   { key: 'cyber_cnapp', label: 'Cybersecurity - CNAPP / CSPM / CWPP', category: 'Cybersecurity', subdomain: 'CNAPP / CSPM / CWPP' },
  //   { key: 'cyber_dlp', label: 'Cybersecurity - Data Loss Prevention (DLP)', category: 'Cybersecurity', subdomain: 'Data Loss Prevention (DLP)' },
  //   { key: 'cyber_data_protection', label: 'Cybersecurity - Data Protection/Backup', category: 'Cybersecurity', subdomain: 'Data Protection/Backup' },
  //   { key: 'cyber_dspm', label: 'Cybersecurity - Data Security Posture Management (DSPM)', category: 'Cybersecurity', subdomain: 'Data Security Posture Management (DSPM)' },
  //   { key: 'cyber_email_security', label: 'Cybersecurity - Email Security / SEG', category: 'Cybersecurity', subdomain: 'Email Security / SEG' },
  //   { key: 'cyber_endpoint_management', label: 'Cybersecurity - Endpoint Management & UEM', category: 'Cybersecurity', subdomain: 'Endpoint Management & UEM' },
  //   { key: 'cyber_endpoint_edr', label: 'Cybersecurity - Endpoint/EDR/XDR', category: 'Cybersecurity', subdomain: 'Endpoint/EDR/XDR' },
  //   { key: 'cyber_iam', label: 'Cybersecurity - Identity & Access Management (IAM)', category: 'Cybersecurity', subdomain: 'Identity & Access Management (IAM)' },
  //   { key: 'cyber_iga', label: 'Cybersecurity - Identity Governance & Administration (IGA)', category: 'Cybersecurity', subdomain: 'Identity Governance & Administration (IGA)' },
  //   { key: 'cyber_itam', label: 'Cybersecurity - IT Asset & Software Asset Mgmt (ITAM/SAM)', category: 'Cybersecurity', subdomain: 'IT Asset & Software Asset Mgmt (ITAM/SAM)' },
  //   { key: 'cyber_network_security', label: 'Cybersecurity - Network Security/NGFW', category: 'Cybersecurity', subdomain: 'Network Security/NGFW' },
  //   { key: 'cyber_pki', label: 'Cybersecurity - PKI & Certificate Management', category: 'Cybersecurity', subdomain: 'PKI & Certificate Management' },
  //   { key: 'cyber_pam', label: 'Cybersecurity - Privileged Access Management (PAM)', category: 'Cybersecurity', subdomain: 'Privileged Access Management (PAM)' },
  //   { key: 'cyber_secrets_management', label: 'Cybersecurity - Secrets Management / Vaults & KMS', category: 'Cybersecurity', subdomain: 'Secrets Management / Vaults & KMS' },
  //   { key: 'cyber_siem_soar', label: 'Cybersecurity - SIEM/SOAR', category: 'Cybersecurity', subdomain: 'SIEM/SOAR' },
  //   { key: 'cyber_ztna', label: 'Cybersecurity - Zero Trust Network Access (ZTNA) / SASE', category: 'Cybersecurity', subdomain: 'Zero Trust Network Access (ZTNA) / SASE' },
  //   // Data & Analytics
  //   { key: 'data_bi', label: 'Data & Analytics - BI & Visualization', category: 'Data & Analytics', subdomain: 'BI & Visualization' },
  //   { key: 'data_bigdata', label: 'Data & Analytics - Big Data & Streaming', category: 'Data & Analytics', subdomain: 'Big Data & Streaming' },
  //   { key: 'data_catalog', label: 'Data & Analytics - Data Catalog & Governance', category: 'Data & Analytics', subdomain: 'Data Catalog & Governance' },
  //   { key: 'data_lineage', label: 'Data & Analytics - Data Lineage & Observability', category: 'Data & Analytics', subdomain: 'Data Lineage & Observability' },
  //   { key: 'data_warehouse', label: 'Data & Analytics - Data Warehousing/Lakehouse', category: 'Data & Analytics', subdomain: 'Data Warehousing/Lakehouse' },
  //   { key: 'data_nosql', label: 'Data & Analytics - Databases (NoSQL/Other)', category: 'Data & Analytics', subdomain: 'Databases (NoSQL/Other)' },
  //   { key: 'data_relational', label: 'Data & Analytics - Databases (Relational)', category: 'Data & Analytics', subdomain: 'Databases (Relational)' },
  //   { key: 'data_etl', label: 'Data & Analytics - ETL/ELT & Data Integration', category: 'Data & Analytics', subdomain: 'ETL/ELT & Data Integration' },
  //   { key: 'data_feature_store', label: 'Data & Analytics - Feature Stores', category: 'Data & Analytics', subdomain: 'Feature Stores' },
  //   { key: 'data_mdm', label: 'Data & Analytics - MDM & Data Quality', category: 'Data & Analytics', subdomain: 'MDM & Data Quality' },
  //   { key: 'data_observability', label: 'Data & Analytics - Observability/Monitoring', category: 'Data & Analytics', subdomain: 'Observability/Monitoring' },
  //   { key: 'data_reverse_etl', label: 'Data & Analytics - Reverse ETL / Data Activation', category: 'Data & Analytics', subdomain: 'Reverse ETL / Data Activation' },
  //   // Digital Experience
  //   { key: 'digital_collaboration', label: 'Digital Experience - Collaboration & Productivity', category: 'Digital Experience', subdomain: 'Collaboration & Productivity' },
  //   { key: 'digital_cdp', label: 'Digital Experience - Customer Data Platforms (CDP)', category: 'Digital Experience', subdomain: 'Customer Data Platforms (CDP)' },
  //   { key: 'digital_ecommerce', label: 'Digital Experience - E‑Commerce Platforms', category: 'Digital Experience', subdomain: 'E‑Commerce Platforms' },
  //   { key: 'digital_experimentation', label: 'Digital Experience - Experimentation & Personalization', category: 'Digital Experience', subdomain: 'Experimentation & Personalization' },
  //   { key: 'digital_headless_cms', label: 'Digital Experience - Headless CMS', category: 'Digital Experience', subdomain: 'Headless CMS' },
  //   { key: 'digital_marketing', label: 'Digital Experience - Marketing Automation & CDP', category: 'Digital Experience', subdomain: 'Marketing Automation & CDP' },
  //   { key: 'digital_web_cms', label: 'Digital Experience - Web CMS (Enterprise)', category: 'Digital Experience', subdomain: 'Web CMS (Enterprise)' },
  //   // Enterprise Applications
  //   { key: 'enterprise_crm', label: 'Enterprise Applications - CRM', category: 'Enterprise Applications', subdomain: 'CRM' },
  //   { key: 'enterprise_customer_service', label: 'Enterprise Applications - Customer Service/ITSM', category: 'Enterprise Applications', subdomain: 'Customer Service/ITSM' },
  //   { key: 'enterprise_erp', label: 'Enterprise Applications - ERP', category: 'Enterprise Applications', subdomain: 'ERP' },
  //   { key: 'enterprise_finance', label: 'Enterprise Applications - Finance & EPM', category: 'Enterprise Applications', subdomain: 'Finance & EPM' },
  //   { key: 'enterprise_hcm', label: 'Enterprise Applications - HCM', category: 'Enterprise Applications', subdomain: 'HCM' },
  //   { key: 'enterprise_supply_chain', label: 'Enterprise Applications - Supply Chain & Procurement', category: 'Enterprise Applications', subdomain: 'Supply Chain & Procurement' },
  //   // Industry Solutions
  //   { key: 'industry_banking', label: 'Industry Solutions - Banking/Financial Services', category: 'Industry Solutions', subdomain: 'Banking/Financial Services' },
  //   { key: 'industry_healthcare', label: 'Industry Solutions - Healthcare EMR/EHR', category: 'Industry Solutions', subdomain: 'Healthcare EMR/EHR' },
  //   { key: 'industry_highered', label: 'Industry Solutions - Higher‑Ed SIS/ERP', category: 'Industry Solutions', subdomain: 'Higher‑Ed SIS/ERP' },
  //   { key: 'industry_insurance', label: 'Industry Solutions - Insurance Core Systems', category: 'Industry Solutions', subdomain: 'Insurance Core Systems' },
  //   { key: 'industry_manufacturing', label: 'Industry Solutions - Manufacturing/PLM/MES', category: 'Industry Solutions', subdomain: 'Manufacturing/PLM/MES' },
  //   { key: 'industry_public_sector', label: 'Industry Solutions - Public Sector ERP', category: 'Industry Solutions', subdomain: 'Public Sector ERP' },
  //   { key: 'industry_retail', label: 'Industry Solutions - Retail & POS', category: 'Industry Solutions', subdomain: 'Retail & POS' },
  //   { key: 'industry_telecom', label: 'Industry Solutions - Telecom OSS/BSS', category: 'Industry Solutions', subdomain: 'Telecom OSS/BSS' },
  //   // IT Operations
  //   { key: 'itops_aiops', label: 'IT Operations - AIOps Platforms', category: 'IT Operations', subdomain: 'AIOps Platforms' },
  //   { key: 'itops_apm', label: 'IT Operations - APM/Observability', category: 'IT Operations', subdomain: 'APM/Observability' },
  //   { key: 'itops_itom', label: 'IT Operations - ITOM/CMDB', category: 'IT Operations', subdomain: 'ITOM/CMDB' },
  //   { key: 'itops_itsm', label: 'IT Operations - ITSM Platforms', category: 'IT Operations', subdomain: 'ITSM Platforms' },
  //   // Project & Portfolio
  //   { key: 'project_agile', label: 'Project & Portfolio - Agile/Work Management', category: 'Project & Portfolio', subdomain: 'Agile/Work Management' },
  //   { key: 'project_ppm', label: 'Project & Portfolio - PPM/Enterprise PM', category: 'Project & Portfolio', subdomain: 'PPM/Enterprise PM' },
  //   // Software Development
  //   { key: 'software_frontend', label: 'Software Development - Front-End Frameworks', category: 'Software Development', subdomain: 'Front-End Frameworks' },
  //   { key: 'software_languages', label: 'Software Development - Languages & Runtimes', category: 'Software Development', subdomain: 'Languages & Runtimes' },
  //   { key: 'software_mobile', label: 'Software Development - Mobile Development', category: 'Software Development', subdomain: 'Mobile Development' },
  //   { key: 'software_testing', label: 'Software Development - Testing & QA', category: 'Software Development', subdomain: 'Testing & QA' },
  //   { key: 'software_web_backend', label: 'Software Development - Web & Backend Frameworks', category: 'Software Development', subdomain: 'Web & Backend Frameworks' },
  //   { key: 'add_new_option', label: '-- Add New --' },
  // ],

  // staffingServiceDomainsOptions: [
  //   // AI & Emerging Tech
  //   { key: 'ai_llm_apis_stacks', label: 'AI & Emerging Tech - AI/LLM APIs & Stacks', category: 'AI & Emerging Tech', subdomain: 'AI/LLM APIs & Stacks' },
  //   { key: 'ai_arvr_xr', label: 'AI & Emerging Tech - AR/VR/XR', category: 'AI & Emerging Tech', subdomain: 'AR/VR/XR' },
  //   { key: 'ai_computer_vision', label: 'AI & Emerging Tech - Computer Vision', category: 'AI & Emerging Tech', subdomain: 'Computer Vision' },
  //   { key: 'ai_iot_platforms', label: 'AI & Emerging Tech - IoT Platforms', category: 'AI & Emerging Tech', subdomain: 'IoT Platforms' },
  //   { key: 'ai_ml_platforms_mlops', label: 'AI & Emerging Tech - ML Platforms & MLOps', category: 'AI & Emerging Tech', subdomain: 'ML Platforms & MLOps' },
  //   { key: 'ai_nlp_libraries', label: 'AI & Emerging Tech - NLP Libraries', category: 'AI & Emerging Tech', subdomain: 'NLP Libraries' },
  //   { key: 'ai_rag_frameworks_eval', label: 'AI & Emerging Tech - RAG Frameworks & Eval', category: 'AI & Emerging Tech', subdomain: 'RAG Frameworks & Eval' },
  //   { key: 'ai_rpa_automation', label: 'AI & Emerging Tech - RPA/Automation', category: 'AI & Emerging Tech', subdomain: 'RPA/Automation' },
  //   { key: 'ai_vector_databases', label: 'AI & Emerging Tech - Vector Databases', category: 'AI & Emerging Tech', subdomain: 'Vector Databases' },
  //   // Cloud & DevOps
  //   { key: 'cloud_api_management', label: 'Cloud & DevOps - API Management & Gateways', category: 'Cloud & DevOps', subdomain: 'API Management & Gateways' },
  //   { key: 'cloud_artifact_repositories', label: 'Cloud & DevOps - Artifact Repositories & Build', category: 'Cloud & DevOps', subdomain: 'Artifact Repositories & Build' },
  //   { key: 'cloud_backup_draas', label: 'Cloud & DevOps - Backup & DRaaS / BaaS', category: 'Cloud & DevOps', subdomain: 'Backup & DRaaS / BaaS' },
  //   { key: 'cloud_feature_flags', label: 'Cloud & DevOps - Feature Flags & Experimentation', category: 'Cloud & DevOps', subdomain: 'Feature Flags & Experimentation' },
  //   { key: 'cloud_finops', label: 'Cloud & DevOps - FinOps / Cloud Cost Management', category: 'Cloud & DevOps', subdomain: 'FinOps / Cloud Cost Management' },
  //   { key: 'cloud_incident_management', label: 'Cloud & DevOps - Incident & On‑Call Management', category: 'Cloud & DevOps', subdomain: 'Incident & On‑Call Management' },
  //   { key: 'cloud_service_mesh', label: 'Cloud & DevOps - Service Mesh', category: 'Cloud & DevOps', subdomain: 'Service Mesh' },
  //   // Cloud & Infrastructure
  //   { key: 'cloud_platforms', label: 'Cloud & Infrastructure - Cloud Platforms (IaaS/PaaS)', category: 'Cloud & Infrastructure', subdomain: 'Cloud Platforms (IaaS/PaaS)' },
  //   { key: 'cloud_containerization', label: 'Cloud & Infrastructure - Containerization & Orchestration', category: 'Cloud & Infrastructure', subdomain: 'Containerization & Orchestration' },
  //   { key: 'cloud_devops_cicd', label: 'Cloud & Infrastructure - DevOps & CI/CD', category: 'Cloud & Infrastructure', subdomain: 'DevOps & CI/CD' },
  //   { key: 'cloud_infra_iaas', label: 'Cloud & Infrastructure - Infrastructure as Code (IaC)', category: 'Cloud & Infrastructure', subdomain: 'Infrastructure as Code (IaC)' },
  //   { key: 'cloud_networking', label: 'Cloud & Infrastructure - Networking & CDN', category: 'Cloud & Infrastructure', subdomain: 'Networking & CDN' },
  //   { key: 'cloud_virtualization', label: 'Cloud & Infrastructure - Virtualization & VDI', category: 'Cloud & Infrastructure', subdomain: 'Virtualization & VDI' },
  //   // Cybersecurity
  //   { key: 'cyber_casb_sse', label: 'Cybersecurity - Cloud Access Security Broker (CASB) / SSE', category: 'Cybersecurity', subdomain: 'Cloud Access Security Broker (CASB) / SSE' },
  //   { key: 'cyber_ciem', label: 'Cybersecurity - Cloud Infra Entitlement Mgmt (CIEM)', category: 'Cybersecurity', subdomain: 'Cloud Infra Entitlement Mgmt (CIEM)' },
  //   { key: 'cyber_cloud_security', label: 'Cybersecurity - Cloud Security Posture/CNAPP', category: 'Cybersecurity', subdomain: 'Cloud Security Posture/CNAPP' },
  //   { key: 'cyber_cnapp', label: 'Cybersecurity - CNAPP / CSPM / CWPP', category: 'Cybersecurity', subdomain: 'CNAPP / CSPM / CWPP' },
  //   { key: 'cyber_dlp', label: 'Cybersecurity - Data Loss Prevention (DLP)', category: 'Cybersecurity', subdomain: 'Data Loss Prevention (DLP)' },
  //   { key: 'cyber_data_protection', label: 'Cybersecurity - Data Protection/Backup', category: 'Cybersecurity', subdomain: 'Data Protection/Backup' },
  //   { key: 'cyber_dspm', label: 'Cybersecurity - Data Security Posture Management (DSPM)', category: 'Cybersecurity', subdomain: 'Data Security Posture Management (DSPM)' },
  //   { key: 'cyber_email_security', label: 'Cybersecurity - Email Security / SEG', category: 'Cybersecurity', subdomain: 'Email Security / SEG' },
  //   { key: 'cyber_endpoint_management', label: 'Cybersecurity - Endpoint Management & UEM', category: 'Cybersecurity', subdomain: 'Endpoint Management & UEM' },
  //   { key: 'cyber_endpoint_edr', label: 'Cybersecurity - Endpoint/EDR/XDR', category: 'Cybersecurity', subdomain: 'Endpoint/EDR/XDR' },
  //   { key: 'cyber_iam', label: 'Cybersecurity - Identity & Access Management (IAM)', category: 'Cybersecurity', subdomain: 'Identity & Access Management (IAM)' },
  //   { key: 'cyber_iga', label: 'Cybersecurity - Identity Governance & Administration (IGA)', category: 'Cybersecurity', subdomain: 'Identity Governance & Administration (IGA)' },
  //   { key: 'cyber_itam', label: 'Cybersecurity - IT Asset & Software Asset Mgmt (ITAM/SAM)', category: 'Cybersecurity', subdomain: 'IT Asset & Software Asset Mgmt (ITAM/SAM)' },
  //   { key: 'cyber_network_security', label: 'Cybersecurity - Network Security/NGFW', category: 'Cybersecurity', subdomain: 'Network Security/NGFW' },
  //   { key: 'cyber_pki', label: 'Cybersecurity - PKI & Certificate Management', category: 'Cybersecurity', subdomain: 'PKI & Certificate Management' },
  //   { key: 'cyber_pam', label: 'Cybersecurity - Privileged Access Management (PAM)', category: 'Cybersecurity', subdomain: 'Privileged Access Management (PAM)' },
  //   { key: 'cyber_secrets_management', label: 'Cybersecurity - Secrets Management / Vaults & KMS', category: 'Cybersecurity', subdomain: 'Secrets Management / Vaults & KMS' },
  //   { key: 'cyber_siem_soar', label: 'Cybersecurity - SIEM/SOAR', category: 'Cybersecurity', subdomain: 'SIEM/SOAR' },
  //   { key: 'cyber_ztna', label: 'Cybersecurity - Zero Trust Network Access (ZTNA) / SASE', category: 'Cybersecurity', subdomain: 'Zero Trust Network Access (ZTNA) / SASE' },
  //   // Data & Analytics
  //   { key: 'data_bi', label: 'Data & Analytics - BI & Visualization', category: 'Data & Analytics', subdomain: 'BI & Visualization' },
  //   { key: 'data_bigdata', label: 'Data & Analytics - Big Data & Streaming', category: 'Data & Analytics', subdomain: 'Big Data & Streaming' },
  //   { key: 'data_catalog', label: 'Data & Analytics - Data Catalog & Governance', category: 'Data & Analytics', subdomain: 'Data Catalog & Governance' },
  //   { key: 'data_lineage', label: 'Data & Analytics - Data Lineage & Observability', category: 'Data & Analytics', subdomain: 'Data Lineage & Observability' },
  //   { key: 'data_warehouse', label: 'Data & Analytics - Data Warehousing/Lakehouse', category: 'Data & Analytics', subdomain: 'Data Warehousing/Lakehouse' },
  //   { key: 'data_nosql', label: 'Data & Analytics - Databases (NoSQL/Other)', category: 'Data & Analytics', subdomain: 'Databases (NoSQL/Other)' },
  //   { key: 'data_relational', label: 'Data & Analytics - Databases (Relational)', category: 'Data & Analytics', subdomain: 'Databases (Relational)' },
  //   { key: 'data_etl', label: 'Data & Analytics - ETL/ELT & Data Integration', category: 'Data & Analytics', subdomain: 'ETL/ELT & Data Integration' },
  //   { key: 'data_feature_store', label: 'Data & Analytics - Feature Stores', category: 'Data & Analytics', subdomain: 'Feature Stores' },
  //   { key: 'data_mdm', label: 'Data & Analytics - MDM & Data Quality', category: 'Data & Analytics', subdomain: 'MDM & Data Quality' },
  //   { key: 'data_observability', label: 'Data & Analytics - Observability/Monitoring', category: 'Data & Analytics', subdomain: 'Observability/Monitoring' },
  //   { key: 'data_reverse_etl', label: 'Data & Analytics - Reverse ETL / Data Activation', category: 'Data & Analytics', subdomain: 'Reverse ETL / Data Activation' },
  //   // Digital Experience
  //   { key: 'digital_collaboration', label: 'Digital Experience - Collaboration & Productivity', category: 'Digital Experience', subdomain: 'Collaboration & Productivity' },
  //   { key: 'digital_cdp', label: 'Digital Experience - Customer Data Platforms (CDP)', category: 'Digital Experience', subdomain: 'Customer Data Platforms (CDP)' },
  //   { key: 'digital_ecommerce', label: 'Digital Experience - E‑Commerce Platforms', category: 'Digital Experience', subdomain: 'E‑Commerce Platforms' },
  //   { key: 'digital_experimentation', label: 'Digital Experience - Experimentation & Personalization', category: 'Digital Experience', subdomain: 'Experimentation & Personalization' },
  //   { key: 'digital_headless_cms', label: 'Digital Experience - Headless CMS', category: 'Digital Experience', subdomain: 'Headless CMS' },
  //   { key: 'digital_marketing', label: 'Digital Experience - Marketing Automation & CDP', category: 'Digital Experience', subdomain: 'Marketing Automation & CDP' },
  //   { key: 'digital_web_cms', label: 'Digital Experience - Web CMS (Enterprise)', category: 'Digital Experience', subdomain: 'Web CMS (Enterprise)' },
  //   // Enterprise Applications
  //   { key: 'enterprise_crm', label: 'Enterprise Applications - CRM', category: 'Enterprise Applications', subdomain: 'CRM' },
  //   { key: 'enterprise_customer_service', label: 'Enterprise Applications - Customer Service/ITSM', category: 'Enterprise Applications', subdomain: 'Customer Service/ITSM' },
  //   { key: 'enterprise_erp', label: 'Enterprise Applications - ERP', category: 'Enterprise Applications', subdomain: 'ERP' },
  //   { key: 'enterprise_finance', label: 'Enterprise Applications - Finance & EPM', category: 'Enterprise Applications', subdomain: 'Finance & EPM' },
  //   { key: 'enterprise_hcm', label: 'Enterprise Applications - HCM', category: 'Enterprise Applications', subdomain: 'HCM' },
  //   { key: 'enterprise_supply_chain', label: 'Enterprise Applications - Supply Chain & Procurement', category: 'Enterprise Applications', subdomain: 'Supply Chain & Procurement' },
  //   // Industry Solutions
  //   { key: 'industry_banking', label: 'Industry Solutions - Banking/Financial Services', category: 'Industry Solutions', subdomain: 'Banking/Financial Services' },
  //   { key: 'industry_healthcare', label: 'Industry Solutions - Healthcare EMR/EHR', category: 'Industry Solutions', subdomain: 'Healthcare EMR/EHR' },
  //   { key: 'industry_highered', label: 'Industry Solutions - Higher‑Ed SIS/ERP', category: 'Industry Solutions', subdomain: 'Higher‑Ed SIS/ERP' },
  //   { key: 'industry_insurance', label: 'Industry Solutions - Insurance Core Systems', category: 'Industry Solutions', subdomain: 'Insurance Core Systems' },
  //   { key: 'industry_manufacturing', label: 'Industry Solutions - Manufacturing/PLM/MES', category: 'Industry Solutions', subdomain: 'Manufacturing/PLM/MES' },
  //   { key: 'industry_public_sector', label: 'Industry Solutions - Public Sector ERP', category: 'Industry Solutions', subdomain: 'Public Sector ERP' },
  //   { key: 'industry_retail', label: 'Industry Solutions - Retail & POS', category: 'Industry Solutions', subdomain: 'Retail & POS' },
  //   { key: 'industry_telecom', label: 'Industry Solutions - Telecom OSS/BSS', category: 'Industry Solutions', subdomain: 'Telecom OSS/BSS' },
  //   // IT Operations
  //   { key: 'itops_aiops', label: 'IT Operations - AIOps Platforms', category: 'IT Operations', subdomain: 'AIOps Platforms' },
  //   { key: 'itops_apm', label: 'IT Operations - APM/Observability', category: 'IT Operations', subdomain: 'APM/Observability' },
  //   { key: 'itops_itom', label: 'IT Operations - ITOM/CMDB', category: 'IT Operations', subdomain: 'ITOM/CMDB' },
  //   { key: 'itops_itsm', label: 'IT Operations - ITSM Platforms', category: 'IT Operations', subdomain: 'ITSM Platforms' },
  //   // Project & Portfolio
  //   { key: 'project_agile', label: 'Project & Portfolio - Agile/Work Management', category: 'Project & Portfolio', subdomain: 'Agile/Work Management' },
  //   { key: 'project_ppm', label: 'Project & Portfolio - PPM/Enterprise PM', category: 'Project & Portfolio', subdomain: 'PPM/Enterprise PM' },
  //   // Software Development
  //   { key: 'software_frontend', label: 'Software Development - Front-End Frameworks', category: 'Software Development', subdomain: 'Front-End Frameworks' },
  //   { key: 'software_languages', label: 'Software Development - Languages & Runtimes', category: 'Software Development', subdomain: 'Languages & Runtimes' },
  //   { key: 'software_mobile', label: 'Software Development - Mobile Development', category: 'Software Development', subdomain: 'Mobile Development' },
  //   { key: 'software_testing', label: 'Software Development - Testing & QA', category: 'Software Development', subdomain: 'Testing & QA' },
  //   { key: 'software_web_backend', label: 'Software Development - Web & Backend Frameworks', category: 'Software Development', subdomain: 'Web & Backend Frameworks' },
  //   { key: 'add_new_option', label: '-- Add New --' },
  // ],

  serviceDomainsOptions: [
    // AI & Emerging Tech
    { key: 'ai_llm_apis_stacks', label: 'AI & Emerging Tech - AI/LLM APIs & Stacks', category: 'AI & Emerging Tech', subdomain: 'AI/LLM APIs & Stacks' },
    { key: 'ai_arvr_xr', label: 'AI & Emerging Tech - AR/VR/XR', category: 'AI & Emerging Tech', subdomain: 'AR/VR/XR' },
    { key: 'ai_computer_vision', label: 'AI & Emerging Tech - Computer Vision', category: 'AI & Emerging Tech', subdomain: 'Computer Vision' },
    { key: 'ai_iot_platforms', label: 'AI & Emerging Tech - IoT Platforms', category: 'AI & Emerging Tech', subdomain: 'IoT Platforms' },
    { key: 'ai_ml_platforms_mlops', label: 'AI & Emerging Tech - ML Platforms & MLOps', category: 'AI & Emerging Tech', subdomain: 'ML Platforms & MLOps' },
    { key: 'ai_nlp_libraries', label: 'AI & Emerging Tech - NLP Libraries', category: 'AI & Emerging Tech', subdomain: 'NLP Libraries' },
    { key: 'ai_rag_frameworks_eval', label: 'AI & Emerging Tech - RAG Frameworks & Eval', category: 'AI & Emerging Tech', subdomain: 'RAG Frameworks & Eval' },
    { key: 'ai_rpa_automation', label: 'AI & Emerging Tech - RPA/Automation', category: 'AI & Emerging Tech', subdomain: 'RPA/Automation' },
    { key: 'ai_vector_databases', label: 'AI & Emerging Tech - Vector Databases', category: 'AI & Emerging Tech', subdomain: 'Vector Databases' },
    // Cloud & DevOps
    { key: 'cloud_api_management', label: 'Cloud & DevOps - API Management & Gateways', category: 'Cloud & DevOps', subdomain: 'API Management & Gateways' },
    { key: 'cloud_artifact_repositories', label: 'Cloud & DevOps - Artifact Repositories & Build', category: 'Cloud & DevOps', subdomain: 'Artifact Repositories & Build' },
    { key: 'cloud_backup_draas', label: 'Cloud & DevOps - Backup & DRaaS / BaaS', category: 'Cloud & DevOps', subdomain: 'Backup & DRaaS / BaaS' },
    { key: 'cloud_feature_flags', label: 'Cloud & DevOps - Feature Flags & Experimentation', category: 'Cloud & DevOps', subdomain: 'Feature Flags & Experimentation' },
    { key: 'cloud_finops', label: 'Cloud & DevOps - FinOps / Cloud Cost Management', category: 'Cloud & DevOps', subdomain: 'FinOps / Cloud Cost Management' },
    { key: 'cloud_incident_management', label: 'Cloud & DevOps - Incident & On‑Call Management', category: 'Cloud & DevOps', subdomain: 'Incident & On‑Call Management' },
    { key: 'cloud_service_mesh', label: 'Cloud & DevOps - Service Mesh', category: 'Cloud & DevOps', subdomain: 'Service Mesh' },
    // Cloud & Infrastructure
    { key: 'cloud_platforms', label: 'Cloud & Infrastructure - Cloud Platforms (IaaS/PaaS)', category: 'Cloud & Infrastructure', subdomain: 'Cloud Platforms (IaaS/PaaS)' },
    { key: 'cloud_containerization', label: 'Cloud & Infrastructure - Containerization & Orchestration', category: 'Cloud & Infrastructure', subdomain: 'Containerization & Orchestration' },
    { key: 'cloud_devops_cicd', label: 'Cloud & Infrastructure - DevOps & CI/CD', category: 'Cloud & Infrastructure', subdomain: 'DevOps & CI/CD' },
    { key: 'cloud_infra_iaas', label: 'Cloud & Infrastructure - Infrastructure as Code (IaC)', category: 'Cloud & Infrastructure', subdomain: 'Infrastructure as Code (IaC)' },
    { key: 'cloud_networking', label: 'Cloud & Infrastructure - Networking & CDN', category: 'Cloud & Infrastructure', subdomain: 'Networking & CDN' },
    { key: 'cloud_virtualization', label: 'Cloud & Infrastructure - Virtualization & VDI', category: 'Cloud & Infrastructure', subdomain: 'Virtualization & VDI' },
    // Cybersecurity
    { key: 'cyber_casb_sse', label: 'Cybersecurity - Cloud Access Security Broker (CASB) / SSE', category: 'Cybersecurity', subdomain: 'Cloud Access Security Broker (CASB) / SSE' },
    { key: 'cyber_ciem', label: 'Cybersecurity - Cloud Infra Entitlement Mgmt (CIEM)', category: 'Cybersecurity', subdomain: 'Cloud Infra Entitlement Mgmt (CIEM)' },
    { key: 'cyber_cloud_security', label: 'Cybersecurity - Cloud Security Posture/CNAPP', category: 'Cybersecurity', subdomain: 'Cloud Security Posture/CNAPP' },
    { key: 'cyber_cnapp', label: 'Cybersecurity - CNAPP / CSPM / CWPP', category: 'Cybersecurity', subdomain: 'CNAPP / CSPM / CWPP' },
    { key: 'cyber_dlp', label: 'Cybersecurity - Data Loss Prevention (DLP)', category: 'Cybersecurity', subdomain: 'Data Loss Prevention (DLP)' },
    { key: 'cyber_data_protection', label: 'Cybersecurity - Data Protection/Backup', category: 'Cybersecurity', subdomain: 'Data Protection/Backup' },
    { key: 'cyber_dspm', label: 'Cybersecurity - Data Security Posture Management (DSPM)', category: 'Cybersecurity', subdomain: 'Data Security Posture Management (DSPM)' },
    { key: 'cyber_email_security', label: 'Cybersecurity - Email Security / SEG', category: 'Cybersecurity', subdomain: 'Email Security / SEG' },
    { key: 'cyber_endpoint_management', label: 'Cybersecurity - Endpoint Management & UEM', category: 'Cybersecurity', subdomain: 'Endpoint Management & UEM' },
    { key: 'cyber_endpoint_edr', label: 'Cybersecurity - Endpoint/EDR/XDR', category: 'Cybersecurity', subdomain: 'Endpoint/EDR/XDR' },
    { key: 'cyber_iam', label: 'Cybersecurity - Identity & Access Management (IAM)', category: 'Cybersecurity', subdomain: 'Identity & Access Management (IAM)' },
    { key: 'cyber_iga', label: 'Cybersecurity - Identity Governance & Administration (IGA)', category: 'Cybersecurity', subdomain: 'Identity Governance & Administration (IGA)' },
    { key: 'cyber_itam', label: 'Cybersecurity - IT Asset & Software Asset Mgmt (ITAM/SAM)', category: 'Cybersecurity', subdomain: 'IT Asset & Software Asset Mgmt (ITAM/SAM)' },
    { key: 'cyber_network_security', label: 'Cybersecurity - Network Security/NGFW', category: 'Cybersecurity', subdomain: 'Network Security/NGFW' },
    { key: 'cyber_pki', label: 'Cybersecurity - PKI & Certificate Management', category: 'Cybersecurity', subdomain: 'PKI & Certificate Management' },
    { key: 'cyber_pam', label: 'Cybersecurity - Privileged Access Management (PAM)', category: 'Cybersecurity', subdomain: 'Privileged Access Management (PAM)' },
    { key: 'cyber_secrets_management', label: 'Cybersecurity - Secrets Management / Vaults & KMS', category: 'Cybersecurity', subdomain: 'Secrets Management / Vaults & KMS' },
    { key: 'cyber_siem_soar', label: 'Cybersecurity - SIEM/SOAR', category: 'Cybersecurity', subdomain: 'SIEM/SOAR' },
    { key: 'cyber_ztna', label: 'Cybersecurity - Zero Trust Network Access (ZTNA) / SASE', category: 'Cybersecurity', subdomain: 'Zero Trust Network Access (ZTNA) / SASE' },
    // Data & Analytics
    { key: 'data_bi', label: 'Data & Analytics - BI & Visualization', category: 'Data & Analytics', subdomain: 'BI & Visualization' },
    { key: 'data_bigdata', label: 'Data & Analytics - Big Data & Streaming', category: 'Data & Analytics', subdomain: 'Big Data & Streaming' },
    { key: 'data_catalog', label: 'Data & Analytics - Data Catalog & Governance', category: 'Data & Analytics', subdomain: 'Data Catalog & Governance' },
    { key: 'data_lineage', label: 'Data & Analytics - Data Lineage & Observability', category: 'Data & Analytics', subdomain: 'Data Lineage & Observability' },
    { key: 'data_warehouse', label: 'Data & Analytics - Data Warehousing/Lakehouse', category: 'Data & Analytics', subdomain: 'Data Warehousing/Lakehouse' },
    { key: 'data_nosql', label: 'Data & Analytics - Databases (NoSQL/Other)', category: 'Data & Analytics', subdomain: 'Databases (NoSQL/Other)' },
    { key: 'data_relational', label: 'Data & Analytics - Databases (Relational)', category: 'Data & Analytics', subdomain: 'Databases (Relational)' },
    { key: 'data_etl', label: 'Data & Analytics - ETL/ELT & Data Integration', category: 'Data & Analytics', subdomain: 'ETL/ELT & Data Integration' },
    { key: 'data_feature_store', label: 'Data & Analytics - Feature Stores', category: 'Data & Analytics', subdomain: 'Feature Stores' },
    { key: 'data_mdm', label: 'Data & Analytics - MDM & Data Quality', category: 'Data & Analytics', subdomain: 'MDM & Data Quality' },
    { key: 'data_observability', label: 'Data & Analytics - Observability/Monitoring', category: 'Data & Analytics', subdomain: 'Observability/Monitoring' },
    { key: 'data_reverse_etl', label: 'Data & Analytics - Reverse ETL / Data Activation', category: 'Data & Analytics', subdomain: 'Reverse ETL / Data Activation' },
    // Digital Experience
    { key: 'digital_collaboration', label: 'Digital Experience - Collaboration & Productivity', category: 'Digital Experience', subdomain: 'Collaboration & Productivity' },
    { key: 'digital_cdp', label: 'Digital Experience - Customer Data Platforms (CDP)', category: 'Digital Experience', subdomain: 'Customer Data Platforms (CDP)' },
    { key: 'digital_ecommerce', label: 'Digital Experience - E‑Commerce Platforms', category: 'Digital Experience', subdomain: 'E‑Commerce Platforms' },
    { key: 'digital_experimentation', label: 'Digital Experience - Experimentation & Personalization', category: 'Digital Experience', subdomain: 'Experimentation & Personalization' },
    { key: 'digital_headless_cms', label: 'Digital Experience - Headless CMS', category: 'Digital Experience', subdomain: 'Headless CMS' },
    { key: 'digital_marketing', label: 'Digital Experience - Marketing Automation & CDP', category: 'Digital Experience', subdomain: 'Marketing Automation & CDP' },
    { key: 'digital_web_cms', label: 'Digital Experience - Web CMS (Enterprise)', category: 'Digital Experience', subdomain: 'Web CMS (Enterprise)' },
    // Enterprise Applications
    { key: 'enterprise_crm', label: 'Enterprise Applications - CRM', category: 'Enterprise Applications', subdomain: 'CRM' },
    { key: 'enterprise_customer_service', label: 'Enterprise Applications - Customer Service/ITSM', category: 'Enterprise Applications', subdomain: 'Customer Service/ITSM' },
    { key: 'enterprise_erp', label: 'Enterprise Applications - ERP', category: 'Enterprise Applications', subdomain: 'ERP' },
    { key: 'enterprise_finance', label: 'Enterprise Applications - Finance & EPM', category: 'Enterprise Applications', subdomain: 'Finance & EPM' },
    { key: 'enterprise_hcm', label: 'Enterprise Applications - HCM', category: 'Enterprise Applications', subdomain: 'HCM' },
    { key: 'enterprise_supply_chain', label: 'Enterprise Applications - Supply Chain & Procurement', category: 'Enterprise Applications', subdomain: 'Supply Chain & Procurement' },
    // Industry Solutions
    { key: 'industry_banking', label: 'Industry Solutions - Banking/Financial Services', category: 'Industry Solutions', subdomain: 'Banking/Financial Services' },
    { key: 'industry_healthcare', label: 'Industry Solutions - Healthcare EMR/EHR', category: 'Industry Solutions', subdomain: 'Healthcare EMR/EHR' },
    { key: 'industry_highered', label: 'Industry Solutions - Higher‑Ed SIS/ERP', category: 'Industry Solutions', subdomain: 'Higher‑Ed SIS/ERP' },
    { key: 'industry_insurance', label: 'Industry Solutions - Insurance Core Systems', category: 'Industry Solutions', subdomain: 'Insurance Core Systems' },
    { key: 'industry_manufacturing', label: 'Industry Solutions - Manufacturing/PLM/MES', category: 'Industry Solutions', subdomain: 'Manufacturing/PLM/MES' },
    { key: 'industry_public_sector', label: 'Industry Solutions - Public Sector ERP', category: 'Industry Solutions', subdomain: 'Public Sector ERP' },
    { key: 'industry_retail', label: 'Industry Solutions - Retail & POS', category: 'Industry Solutions', subdomain: 'Retail & POS' },
    { key: 'industry_telecom', label: 'Industry Solutions - Telecom OSS/BSS', category: 'Industry Solutions', subdomain: 'Telecom OSS/BSS' },
    // IT Operations
    { key: 'itops_aiops', label: 'IT Operations - AIOps Platforms', category: 'IT Operations', subdomain: 'AIOps Platforms' },
    { key: 'itops_apm', label: 'IT Operations - APM/Observability', category: 'IT Operations', subdomain: 'APM/Observability' },
    { key: 'itops_itom', label: 'IT Operations - ITOM/CMDB', category: 'IT Operations', subdomain: 'ITOM/CMDB' },
    { key: 'itops_itsm', label: 'IT Operations - ITSM Platforms', category: 'IT Operations', subdomain: 'ITSM Platforms' },
    // Project & Portfolio
    { key: 'project_agile', label: 'Project & Portfolio - Agile/Work Management', category: 'Project & Portfolio', subdomain: 'Agile/Work Management' },
    { key: 'project_ppm', label: 'Project & Portfolio - PPM/Enterprise PM', category: 'Project & Portfolio', subdomain: 'PPM/Enterprise PM' },
    // Software Development
    { key: 'software_frontend', label: 'Software Development - Front-End Frameworks', category: 'Software Development', subdomain: 'Front-End Frameworks' },
    { key: 'software_languages', label: 'Software Development - Languages & Runtimes', category: 'Software Development', subdomain: 'Languages & Runtimes' },
    { key: 'software_mobile', label: 'Software Development - Mobile Development', category: 'Software Development', subdomain: 'Mobile Development' },
    { key: 'software_testing', label: 'Software Development - Testing & QA', category: 'Software Development', subdomain: 'Testing & QA' },
    { key: 'software_web_backend', label: 'Software Development - Web & Backend Frameworks', category: 'Software Development', subdomain: 'Web & Backend Frameworks' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  industriesServedOptions: [
    { key: 'Healthcare', label: 'Healthcare' },
    { key: 'Finance', label: 'Finance' },
    { key: 'PublicSector', label: 'Public Sector' },
    { key: 'Manufacturing', label: 'Manufacturing' },
    { key: 'Retail', label: 'Retail' },
    { key: 'Tech', label: 'Tech' },
    // { key: 'Other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  securityAndComplianceStandardsOptions: [
    { key: 'SOC2', label: 'SOC 2' },
    { key: 'HIPAA', label: 'HIPAA' },
    { key: 'FedRAMP', label: 'FedRAMP' },
    { key: 'GDPR', label: 'GDPR' },
    { key: 'NA', label: 'N/A' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  contractModelsForStaffingOptions: [
    { key: 'W2', label: 'W2' },
    { key: '1099', label: '1099' },
    { key: 'C2C', label: 'C2C' },
    { key: 'fixedPrice', label: 'Fixed Price' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  procurementSystemUsedOptions: [
    { key: 'SAPAriba', label: 'SAP Ariba' },
    { key: 'coupa', label: 'Coupa' },
    { key: 'workday', label: 'Workday' },
    { key: 'oracle', label: 'Oracle' },
    { key: 'manualOrEmailBased', label: 'Manual / Email-Based' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  certificationsFrameworksOptions: [
    { key: 'ISO9001', label: 'ISO 9001' },
    { key: 'CMMIL3+', label: 'CMMI L3+' },
    { key: 'SOC2', label: 'SOC 2' },
    { key: 'ITIL', label: 'ITIL' },
    { key: 'HIPAA', label: 'HIPAA' },
    { key: 'FedRAMP', label: 'FedRAMP' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  insuranceCoverageOptions: [
    { key: 'General Liability', label: 'General Liability' },
    { key: 'Professional Liability', label: 'Professional Liability' },
    { key: 'Cyber Liability', label: 'Cyber Liability' },
  ],

  // ProfileSettingsForm specific options
  skillExpOptions: [
    { key: '0-1', label: '0-1 year' },
    { key: '1-2', label: '1-2 years' },
    { key: '2-3', label: '2-3 years' },
    { key: '3-5', label: '3-5 years' },
    { key: '5-7', label: '5-7 years' },
    { key: '7-10', label: '7-10 years' },
    { key: '10_plus', label: '10+ years' },
  ],

  // Edit listing details form options

  experienceLevelJobOptions: [
    { key: 'Entry Level', label: 'Entry Level' },
    { key: 'Mid Level', label: 'Mid Level' },
    { key: 'Senior Level', label: 'Senior Level' },
    { key: 'Lead/Principal', label: 'Lead/Principal' },
    { key: 'Executive', label: 'Executive' },
  ],

  employmentTypeJobOptions: [
    { key: 'Full Time', label: 'Full Time' },
    { key: 'Part Time', label: 'Part Time' },
    { key: 'Contract', label: 'Contract' },
    { key: 'Temporary', label: 'Temporary' },
    { key: 'Internship', label: 'Internship' },
  ],

  workEngagementTypeJobOptions: [
    { key: 'W2 Full Time', label: 'W2 Full Time' },
    { key: 'W2 Contract', label: 'W2 Contract' },
    { key: 'Corp-to-Corp (C2C)', label: 'Corp-to-Corp (C2C)' },
    { key: 'C2H', label: 'C2H' },
    { key: '1099', label: '1099' },
    { key: 'Independent Contractor', label: 'Independent Contractor' },
    { key: 'Intern', label: 'Intern' },
  ],

  workSiteTypeJobOptions: [
    { key: 'Remote', label: 'Remote' },
    { key: 'Hybrid', label: 'Hybrid' },
    { key: 'On-site', label: 'On-site' },
  ],

  isTravelRequiredJobOptions: [
    { key: 'Yes', label: 'Yes' },
    { key: 'No', label: 'No' },
  ],

  benifitsPerksJobOptions: [ //not using anywhere
    { key: 'Health Insurance', label: 'Health Insurance' },
    { key: '401k', label: '401k' },
    { key: 'PTO', label: 'PTO' },
    { key: 'Training budget', label: 'Training budget' },
    // { key: 'Other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  workAuthReqJobOptions: [
    { key: 'Authorized to work in the U.S. without employer sponsorship', label: 'Authorized to work in the U.S. without employer sponsorship' },
    { key: 'Authorized to work in the U.S. and requires current/future employer sponsorship', label: 'Authorized to work in the U.S. and requires current/future employer sponsorship' },
    { key: 'Authorized to work in the U.S. for a limited duration (with valid work authorization/EAD)', label: 'Authorized to work in the U.S. for a limited duration (with valid work authorization/EAD)' },
    // { key: 'Open to all candidates legally authorized to work in the U.S.', label: 'Open to all candidates legally authorized to work in the U.S.' },
    { key: 'U.S. Citizenship required', label: 'U.S. Citizenship required' },
    { key: 'Lawful Permanent Resident (Green Card holder)', label: 'Lawful Permanent Resident (Green Card holder)' },
  ],

  workAuthReqDetailsJobOptions: [
    { key: 'Federal law (e.g., ITAR, EAR export control regulations, 22 CFR/15 CFR)', label: 'Federal law (e.g., ITAR, EAR export control regulations, 22 CFR/15 CFR)' },
    { key: 'Federal government contract requiring citizenship', label: 'Federal government contract requiring citizenship' },
    { key: 'Executive Order or agency regulation mandating restriction', label: 'Executive Order or agency regulation mandating restriction' },
    { key: 'Security clearance requirements tied to federal law', label: 'Security clearance requirements tied to federal law' },
  ],

  certificationsRequiredJobOptions: [
    { key: 'Yes', label: 'Yes' },
    { key: 'No', label: 'No' },
  ],

  reportingLineJobOptions: [ //not using anywhere
    { key: 'PM', label: 'PM' },
    { key: 'Director', label: 'Director' },
    { key: 'Client Lead', label: 'Client Lead' },
    { key: 'Vendor Manager', label: 'Vendor Manager' },
    // { key: 'Other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  teamStructureJobOptions: [
    { key: 'Independent', label: 'Independent' },
    { key: 'Internal team', label: 'Internal team' },
    { key: 'Client Team', label: 'Client Team' },
    { key: 'Vendor Partner Team', label: 'Vendor Partner Team' },
    { key: 'Hybrid', label: 'Hybrid' },
    // { key: 'Other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  projectTypeJobOptions: [
    { key: 'Internal Project', label: 'Internal Project' },
    { key: 'Direct End-Client Project', label: 'Direct End-Client Project' },
    {
      key: 'Through Preferred Vendor / Tier-1 Vendor',
      label: 'Through Preferred Vendor / Tier-1 Vendor',
    },
  ],

  endClientIndustryJobOptions: [
    { key: 'Healthcare', label: 'Healthcare' },
    { key: 'Finance', label: 'Finance' },
    { key: 'Retail', label: 'Retail' },
    { key: 'Manufacturing', label: 'Manufacturing' },
    { key: 'Government', label: 'Government' },
    // { key: 'Other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  endClientDisclosureJobOptions: [
    { key: 'Yes', label: 'Yes' },
    { key: 'No', label: 'No' },
  ],

  relationshipToEndClientJobOptions: [
    { key: 'Direct Prime Vendor', label: 'Direct Prime Vendor' },
    { key: 'Sub-vendor to Tier-1/MSP', label: 'Sub-vendor to Tier-1/MSP' },
    { key: 'Independent Staffing Agency', label: 'Independent Staffing Agency' },
    { key: 'None', label: 'None' },
  ],

  MSPVMSSystemJobOptions: [
    { key: 'Beeline', label: 'Beeline' },
    { key: 'Fieldglass', label: 'Fieldglass' },
    { key: 'Coupa', label: 'Coupa' },
    { key: 'Workday', label: 'Workday' },
    { key: 'None', label: 'None' },
    // { key: 'Other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  contractTypeJobOptions: [
    { key: 'Direct Contract', label: 'Direct Contract' },
    { key: 'Subcontract (Select if not direct)', label: 'Subcontract (Select if not direct)' },
    { key: 'SOW-based', label: 'SOW-based' },
    { key: 'Staff Augmentation (T&M)', label: 'Staff Augmentation (T&M)' },
    { key: 'None', label: 'None' },
  ],

  subContractingRulesJobOptions: [
    { key: 'Yes', label: 'Yes' },
    { key: 'No', label: 'No' },
  ],

  complianceRequirementsJobOptions: [
    { key: 'Background Check', label: 'Background Check' },
    { key: 'Security Training', label: 'Security Training' },
    { key: 'Drug Test', label: 'Drug Test' },
    // { key: 'Other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  backChekRequiredOpJobOptions: [
    { key: 'Criminal', label: 'Criminal' },
    { key: 'Employment', label: 'Employment' },
    { key: 'Education', label: 'Education' },
    { key: 'Drug', label: 'Drug' },
  ],

  securityClearanceRequiredDetailsJob: [
    { key: 'Public Trust', label: 'Public Trust' },
    { key: 'Secret', label: 'Secret' },
    { key: 'Top Secret', label: 'Top Secret' },
    // { key: 'Other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  vendorEngagementRulesJobOptions: [
    { key: 'Direct to Client', label: 'Direct to Client' },
    { key: 'MSP Managed', label: 'MSP Managed' },
    { key: 'VMS Portal', label: 'VMS Portal' },
    // { key: 'Other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  applicationInstructionsJobOptions: [
    { key: 'URL', label: 'URL' },
    { key: 'Email', label: 'Email' },
    { key: 'iParley Submission', label: 'iParley Submission' },
  ],

  verificationRequirementsJobOptions: [
    { key: 'Identity', label: 'Identity' },
    { key: 'Work authorization', label: 'Work authorization' },
    // Work Experience and Education are left out until the Wallet verifies them.
    { key: 'None', label: 'None' },
  ],

  requiredSkillsJobOptions: [
    { key: 'react', label: 'React' },
    { key: 'angular', label: 'Angular' },
    { key: 'SAP', label: 'SAP' },
    { key: 'AWS', label: 'AWS' },
    { key: 'Salesforce', label: 'Salesforce' },
    { key: 'Sailpoint', label: 'Sailpoint' },
    { key: 'Azure', label: 'Azure' },
    { key: 'GCP', label: 'GCP' },
    { key: 'Workday', label: 'Workday' },
    { key: 'ServiceNow', label: 'ServiceNow' },
    { key: 'Oracle', label: 'Oracle' },
    { key: 'Microsoft Dynamics', label: 'Microsoft Dynamics' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  issuingOrgTypeRFPOptions: [
    { key: 'State and Local (SLED)', label: 'State and Local (SLED)' },
    { key: 'Federal', label: 'Federal' },
    { key: 'Non-profit', label: 'Non-profit' },
    { key: 'Publicly listed, for-profit', label: 'Publicly listed, for-profit' },
    { key: 'Private, non-profit', label: 'Private, non-profit' },
  ],

  categoryRFPOptions: [
    { key: 'NAICS', label: 'NAICS' },
    { key: 'PSC/FSC', label: 'PSC/FSC' },
    { key: 'NIGP', label: 'NIGP' },
    { key: 'UNSPSC', label: 'UNSPSC' },
    // { key: 'Other', label: 'Other' }
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  projectServiceDomainRFPOptions: [
    { key: 'IAM / Security', label: 'IAM / Security' },
    { key: 'Cloud Migration', label: 'Cloud Migration' },
    { key: 'ERP', label: 'ERP' },
    { key: 'CRM', label: 'CRM' },
    { key: 'DevOps', label: 'DevOps' },
    { key: 'Custom App Development', label: 'Custom App Development' },
    { key: 'Data & AI', label: 'Data & AI' },
    { key: 'Digital Transformation', label: 'Digital Transformation' },
    // { key: 'Other', label: 'Other' }
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  projTechFocusSpecNeedsRFPOptions: [
    { key: 'SAP', label: 'SAP' },
    { key: 'AWS', label: 'AWS' },
    { key: 'Salesforce', label: 'Salesforce' },
    { key: 'SailPoint', label: 'SailPoint' },
    { key: 'Java', label: 'Java' },
    { key: 'Python', label: 'Python' },
    { key: 'Azure', label: 'Azure' },
    { key: 'GCP', label: 'GCP' },
    { key: 'Workday', label: 'Workday' },
    { key: 'ServiceNow', label: 'ServiceNow' },
    { key: 'Oracle', label: 'Oracle' },
    { key: 'Microsoft Dynamics', label: 'Microsoft Dynamics' },
    // { key: 'Other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  submissionPortalMethodRFPOptions: [
    { key: 'Portal', label: 'Portal' },
    { key: 'Email', label: 'Email' },
    { key: 'URL', label: 'URL' },
    // { key: 'Other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  certificationsStandardsRFPOptions: [
    { key: 'SOC2', label: 'SOC2' },
    { key: 'ISO', label: 'ISO' },
    { key: 'HIPAA', label: 'HIPAA' },
    { key: 'FedRAMP', label: 'FedRAMP' },
    { key: 'None', label: 'None' },
    // { key: 'Other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  contractTypeRFPOptions: [
    { key: 'Fixed price', label: 'Fixed price' },
    { key: 'T&M', label: 'T&M' },
    { key: 'Milestone based', label: 'Milestone based' },
    { key: 'Hybrid', label: 'Hybrid' },
  ],

  deliveryModelsRFPOptions: [
    { key: 'Onsite', label: 'Onsite' },
    { key: 'Offsite', label: 'Offsite' },
    { key: 'Offshore', label: 'Offshore' },
    { key: 'Hybrid', label: 'Hybrid' },
  ],

  paymentTermsSelectRFPOptions: [
    { key: 'Weekly', label: 'Weekly' },
    { key: 'Bi-weekly', label: 'Bi-weekly' },
    { key: 'Net 30', label: 'Net 30' },
    { key: 'Net 45', label: 'Net 45' },
    { key: 'Net 60', label: 'Net 60' },
    { key: 'Net 90', label: 'Net 90' },
  ],

  securityCertificationsRFPOptions: [
    { key: 'SOC2', label: 'SOC2' },
    { key: 'ISO27001', label: 'ISO27001' },
    { key: 'FedRAMP', label: 'FedRAMP' },
    { key: 'PCI', label: 'PCI' },
    { key: 'ISO 9001', label: 'ISO 9001' },
    { key: 'CMMI Level 3+', label: 'CMMI Level 3+' },
    // { key: 'Other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  diversityCertificationsRFPOptions: [
    { key: 'Minority-Owned', label: 'Minority-Owned' },
    { key: 'Woman-Owned', label: 'Woman-Owned' },
    { key: 'Veteran-Owned', label: 'Veteran-Owned' },
    { key: 'SBA 8(a)', label: 'SBA 8(a)' },
    { key: 'NMSDC', label: 'NMSDC' },
    // { key: 'Other', label: 'Other' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  contractTermsRFPOptions: [
    { key: 'Yes', label: 'Yes' },
    { key: 'No', label: 'No' },
    { key: 'By Approval', label: 'By Approval' },
  ],

  securityRequirementsRFPOptions: [
    { key: 'IAM', label: 'IAM' },
    { key: 'SSO', label: 'SSO' },
    { key: 'MFA', label: 'MFA' },
    { key: 'Encryption', label: 'Encryption' },
    { key: 'EDR', label: 'EDR' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  securityAndComplianceRFPOptions: [
    { key: 'SOC2', label: 'SOC2' },
    { key: 'ISO27001', label: 'ISO27001' },
    { key: 'HIPAA', label: 'HIPAA' },
    { key: 'PCI', label: 'PCI' },
    { key: 'FedRAMP', label: 'FedRAMP' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  dataProtectionControlsRFPOptions: [
    { key: 'DPA', label: 'DPA' },
    { key: 'SCCs', label: 'SCCs' },
    { key: 'Data Residency', label: 'Data Residency' },
    { key: 'add_new_option', label: '-- Add New --' },
  ],

  requiredVerificationsRFPOptions: [
    { key: 'KYB Status', label: 'KYB Status' },
    { key: 'Beneficial Ownership', label: 'Beneficial Ownership' },
    { key: 'Security Certifications', label: 'Security Certifications' },
    { key: 'Past performance evidence', label: 'Past performance evidence' },
  ],

};

export default fieldOptions;

export const getAgencyTypeDisplayLabel = (value) => {
  if (value === 'Staffing Services') return 'Staffing Services';
  return value;
};

export const getCustomerTypeDisplayLabel = (value) => {
  if (value === 'Looking for Staffing Provider') return 'Looking for Staffing Service';
  if (value === 'Looking for Staffing Provider and Implementation Service')
    return 'Looking for Staffing Service and Implementation Service';
  return value;
};
